<template>
    <div class="dialog-page">
        <!-- 初始欢迎消息，仅在没有消息时显示 -->
        <!--        <div v-if="messages.length === 0" class="hero">
                    <div class="ai-message initial-message">
                        <div class="ai-avatar"><img
                                src="https://nuva-hk-t2.oss-cn-hongkong.aliyuncs.com/Person/female/Frame5.png"/></div>
                        <div class="message-content" style="text-align: left">
                            <p>Hey! Looking for something fresh today? I'd love to recommend a few looks for you.</p>
                            <p class="subtle">Tell me what you're looking for – maybe an event or occasion you're dressing for,
                                a vibe you want to try, or a color combo you're into.</p>
                        </div>
                    </div>
                </div>-->

        <!-- 消息列表 -->
        <div class="messages-container" ref="messagesContainer" aria-live="polite">
            <div class="messages">
                <div
                        v-for="(msg, index) in messages"
                        :key="index"
                        :class="['message', msg.type]"
                        :data-scenario="msg.scenario || ''"
                >
                    <!-- 用户消息 -->
                    <div v-if="msg.type === 'user'" class="user-message">
                        <div class="message-content">
                            <!-- 语音消息 -->
                            <VoiceMessageBubble
                                    v-if="msg.voice"
                                    :audio-url="msg.voice.audioUrl"
                                    :duration="msg.voice.duration"
                                    :text="msg.voice.text || msg.content"
                            />
                            <!-- 普通文本消息 -->
                            <!--                            <p v-else>{{ msg.content }}</p>-->
                            <!-- 图片消息 -->
                            <!--                            <img v-if="msg.image" :src="msg.image" alt="用户上传的图片" class="message-image"/>-->
                        </div>
                        <!--                        <div class="message-time">{{ formatTime(msg.timestamp) }}</div>-->
                    </div>

                    <!-- AI回复消息 -->
                    <div v-else-if="msg.type === 'ai'" class="ai-message"
                    >
                        <!-- 场景1: 简单文本回复 (Text) -->
                        <div v-show="msg.scenario === 'Text' || !msg.scenario" class="ai-text-container">
                            <p class="simple-response">{{ msg.content }}</p>
                            <!-- Text场景的操作按钮 -->
                        </div>
                        <div v-show="msg.scenario === 'MoodboardLoading'" class="ai-text-container moodboard-loading-container">
                            <div class="moodboard-loading-frame">
                                <div
                                        class="moodboard-loading-track"
                                        :style="{ transform: `translateX(-${(msg.currentIndex || 0) * 100}%)` }"
                                >
                                    <div
                                            v-for="(imageUrl, imgIndex) in msg.images"
                                            :key="imgIndex"
                                            class="moodboard-loading-slide"
                                    >
                                        <img :src="imageUrl" alt="Moodboard loading" class="moodboard-loading-image">
                                    </div>
                                </div>
                                <div class="moodboard-loading-overlay"></div>
                            </div>
                        </div>
                        <!-- 场景1: 简单文本回复 (Text) -->
                        <div v-show="msg.scenario === 'defaultText' || !msg.scenario" class="ai-text-container">
                            <p class="simple-response">{{ msg.content }}</p>
                            <!-- Text场景的操作按钮 -->
                            <div class="product-actions" v-if="!msg.textConfirmed">
                                <button class="action-btn skip-btn" @click="replenish()">
                                    还要补充
                                </button>
                                <button class="action-btn select-btn" @click="handleTextConfirm(msg)">
                                    开始设计
                                </button>
                            </div>
                        </div>
                        <!-- 场景Text1: 产品选择后的需求询问 -->
                        <div v-show="msg.scenario === 'Text1'" class="ai-text-container">
                            <div class="text1-content">
                                <p class="text1-opening">{{ msg.text1Opening || '哦～好眼光！😎 这个' + (msg.selectedProduct?.name || '单品') + '马上会成为你造型的C位亮点' }}</p>
                                <p class="text1-prompt">{{ msg.text1Prompt || '那现在告诉我你的需求吧！比如：' }}</p>

                                <div class="text1-section">
                                    <p class="text1-label"><strong>我准备下周去参加/出席：</strong></p>
                                    <p class="text1-options">{{ msg.text1Occasion || '音乐节 / 出差 / 约会 / 度假 / 晚宴' }}</p>
                                </div>

                                <div class="text1-section">
                                    <p class="text1-label"><strong>喜欢的风格是比较</strong></p>
                                    <p class="text1-options">{{ msg.text1Style || '飒 / 极简 / 街头 / 优雅 / 时尚 / 未来感' }}</p>
                                </div>

                                <div class="text1-section">
                                    <p class="text1-label"><strong>想要的颜色是</strong></p>
                                    <p class="text1-options">{{ msg.text1Color || '黑白灰 / 大地色系 / 同色系 / 撞色 / 鲜艳 / 素净' }}</p>
                                </div>

                                <p class="text1-closing">{{ msg.text1Closing || '场合 + 风格，我马上为你调出专属 vibe✨～' }}</p>
                            </div>
<!--                            &lt;!&ndash; Text1场景的操作按钮 &ndash;&gt;
                            <div class="product-actions" v-if="!msg.text1Confirmed">
                                <button class="action-btn skip-btn">等等，我有补充</button>
                                <button class="action-btn select-btn" @click="handleText1Confirm(msg)">没错，开始设计吧</button>
                            </div>-->
                        </div>
                        <!-- 场景1: 简单文本回复 (Text+Img) -->
                        <div v-show="msg.scenario === 'editImage'" class="ai-text-container">
                            <p class="simple-response">{{ msg.content }}</p>
                            <div class="image-slider-container">
                                <div class="image-slider" ref="imageSlider">
                                    <div
                                            v-for="(product, index) in msg.products"
                                            :key="index"
                                            class="slider-image-item"
                                            :class="{
                                                'selected': msg.selectedProductIndex === index,
                                                'confirmed': msg.isConfirmed && msg.selectedProductIndex === index,
                                                'unselected': msg.isConfirmed && msg.selectedProductIndex !== index
                                            }"
                                            @click="selectProduct(index, msg)"
                                    >
                                        <img
                                                :src="product.image"
                                                class="slider-image"
                                        >
                                        <!-- 确认后显示对勾标记 -->
                                        <div v-if="msg.isConfirmed && msg.selectedProductIndex === index" class="confirmed-badge">
                                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                                                <circle cx="12" cy="12" r="10" fill="#A6F55D"/>
                                                <path d="M7 12l3 3 7-7" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                        <!-- 选中时显示详细信息（包括确认后） -->
                                        <div v-if="msg.selectedProductIndex === index" class="product-details-inline">
                                            <div class="product-header">
<!--                                                <div class="product-price">¥{{ product.price }}</div>-->
                                                <div class="product-name">{{ product.name }}</div>
                                            </div>
                                            <div class="product-description">{{ product.description }}</div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 隐藏提示文本 -->
                                <p v-if="!msg.isConfirmed" class="product-prompt-text">你想先选一个来搭搭看，还是直接从你的风格开始？💭</p>

                                <!-- 操作按钮 -->
                                <div class="product-actions" v-if="!msg.isConfirmed">
                                    <button class="action-btn select-btn" @click="confirmSelection(msg)">就选它了</button>
                                    <button class="action-btn skip-btn" @click="skipSelection">跳过单品</button>
                                </div>
                            </div>
                        </div>
                        <div v-show="msg.scenario === 'editImage4'" class="ai-text-container">
                            <div class="editimage4-grid-container">
                                <div class="editimage4-grid">
                                    <div
                                            v-for="(product, index) in msg.products"
                                            :key="index"
                                            class="editimage4-grid-item"
                                            :class="{ 
                                                'selected': msg.selectedProductIndex4 === index,
                                                'confirmed': msg.confirmed4 && msg.selectedProductIndex4 === index,
                                                'unselected': msg.confirmed4 && msg.selectedProductIndex4 !== index,
                                                'locked': msg.selectionLocked4
                                            }"
                                            @click="selectProduct4(index, product, msg)"
                                    >
                                        <img
                                                :src="product.image"
                                                class="editimage4-grid-image"
                                        >
                                        <p>{{ product.description }}</p>
                                        <!-- 选中状态指示器 -->
                                        <div v-if="msg.selectedProductIndex4 === index"
                                             class="editimage4-selected-indicator">
                                            <div class="editimage4-checkmark">✓</div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 选中图片放大显示 -->
                                <transition name="collapse" appear mode="out-in" :css="true">
                                    <div v-if="msg.selectedProduct4 && !msg.collapsed"
                                         class="editimage4-selected-display">
                                        <div class="editimage4-image-container">
                                            <!-- 上一张按钮 -->
                                            <button
                                                    v-if="msg.selectedProductIndex4 > 0"
                                                    class="editimage4-nav-btn editimage4-prev-btn"
                                                    @click="prevImage4(msg)"
                                            >
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M15 18L9 12L15 6" stroke="white" stroke-width="2"
                                                          stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </button>

                                            <!-- 大图显示 -->
                                            <img
                                                    :src="msg.selectedProduct4.image"
                                                    class="editimage4-large-image"
                                                    loading="lazy"
                                                    decoding="async"
                                                    referrerpolicy="no-referrer"
                                                    @touchstart="(e) => handleTouchStart4(e, msg)"
                                                    @touchmove="handleTouchMove4"
                                                    @touchend="handleTouchEnd4"
                                            >

                                            <!-- 下一张按钮 -->
                                            <button
                                                    v-if="msg.products && msg.selectedProductIndex4 !== null && msg.selectedProductIndex4 < msg.products.length - 1"
                                                    class="editimage4-nav-btn editimage4-next-btn"
                                                    @click="nextImage4(msg)"
                                            >
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M9 18L15 12L9 6" stroke="white" stroke-width="2"
                                                          stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </button>
                                        </div>
                                        <!-- 第一次：只显示"就它! Next" -->
                                        <transition name="fade" appear>
                                            <div class="editimage4-action-button"
                                                 v-if="msg.appearanceCount === 1 && !msg.collapsed">
                                                <button class="editimage4-confirm-btn"
                                                        @click="confirmSelection1(msg.selectedProduct4.id, msg)">就它!
                                                    Next
                                                </button>
                                            </div>
                                        </transition>
                                        <!-- 第二次：同时显示两个按钮 -->
                                        <transition name="fade" appear>
                                            <div class="editimage4-action-button"
                                                 v-if="msg.appearanceCount === 2 && !msg.collapsed">
                                                <button class="editimage4-confirm-btn"
                                                        @click="confirmSelection1(msg.selectedProduct4.id, msg)">就它!
                                                    Next
                                                </button>
                                                <button class="editimage4-confirm-btn"
                                                        @click="confirmMoodboard(msg.selectedProduct4.id, msg)">
                                                    找到这套LOOK
                                                </button>
                                            </div>
                                        </transition>
                                        <!-- 第三次：只显示"Moodboard" -->
                                        <transition name="fade" appear>
                                            <div class="editimage4-action-button"
                                                 v-if="msg.appearanceCount === 3 && !msg.collapsed">
                                                <button class="editimage4-confirm-btn"
                                                        @click="confirmMoodboard(msg.selectedProduct4.id, msg)">
                                                    找到这套LOOK
                                                </button>
                                            </div>
                                        </transition>
                                    </div>
                                </transition>
                                <p v-if="msg.supplement && msg.collapsed" class="simple-response">{{ msg.supplement }}</p>
                            </div>
                        </div>
                        <div v-show="msg.scenario === 'ImageWithList'" class="ai-text-container">
                            <!-- 只显示第一张图片 -->
                            <div class="imagewithlist-container">
                                <div class="imagewithlist-image-container">
                                    <img
                                            :src="msg.image"
                                            class="imagewithlist-image"
                                            loading="lazy"
                                            decoding="async"
                                            referrerpolicy="no-referrer"
                                    >
                                    <img
                                            v-if="msg.qrImage"
                                            :src="msg.qrImage"
                                            class="imagewithlist-qr"
                                            loading="lazy"
                                            decoding="async"
                                            referrerpolicy="no-referrer"
                                    >
                                </div>
                                <p class="imagewithlist-caption">希望你喜欢这套穿搭～ 扫码可以获取所有LOOK哦～</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 打字指示器 -->
                <div v-if="isTyping" class="message ai typing-indicator">
                    <!--          <div class="ai-avatar">🤖</div>-->
                    <div class="message-content">
                        <div class="typing-indicator-line">
                            <span v-if="typingStatusText" class="typing-status-text">{{ typingStatusText }}</span>
                            <div class="typing-dots">
                            <span></span>
                            <span></span>
                            <span></span>
                            </div>
                        </div>
                    </div>
                </div>
        </div>

        <!-- 图片预览区域 -->
        <!--    <div v-if="uploadedImage" class="image-preview">
              <div class="preview-container">
                <img :src="uploadedImage" alt="预览图片" class="preview-image" />
                <button class="remove-image" @click="removeImage">✕</button>
              </div>
            </div>-->

        <!-- 输入区域容器 -->
<!--        <div class="input-container">
            &lt;!&ndash; 语音录音组件 &ndash;&gt;


            &lt;!&ndash; 相机按钮（在输入框外面） &ndash;&gt;

            &lt;!&ndash; 输入栏 &ndash;&gt;
            <div class="input-bar">
                <input
                        v-model="message"
                        placeholder="Tell me what you are looking for..."
                        @keypress.enter="sendMessage"
                        :disabled="isTyping"
                />
                <button class="btn-send" @click="sendMessage"
                        :disabled="isTyping || (!message.trim() && !uploadedImage)">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22 2L11 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round"/>
                        <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="currentColor" stroke-width="2"
                              stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>

            <input ref="fileInput" type="file" accept="image/*" class="hidden-input" @change="onFileChange"/>
            <button class="btn-attach" @click="triggerUpload" :disabled="isTyping">
                &lt;!&ndash; 默认上传图标 &ndash;&gt;
                <img
                        :src="uploadImg"
                        alt="上传图片"
                        class="upload-icon default-icon"
                        :class="{ 'hidden': uploadedImage }"
                />
                &lt;!&ndash; 悬浮时显示的上传图标 &ndash;&gt;
                <img
                        v-if="uploadedImage"
                        :src="uploadImg"
                        alt="上传图片"
                        class="upload-icon hover-icon"
                />
                &lt;!&ndash; 上传后显示的图片 &ndash;&gt;
                <img
                        v-if="uploadedImage"
                        :src="uploadedImage"
                        alt="已上传的图片"
                        class="upload-icon uploaded-image"
                />
            </button>

        </div>-->

    </div>
    </div>
    <div style="overflow: hidden;">
        <VoiceRecorder
            :on-result="handleVoiceResult"
            class="voice-recorder-component"
        />
    </div>
</template>

<script setup>
import {ref, nextTick, onMounted, onUnmounted} from 'vue'
import ChatApi from '@/api/chat'
// 导入图标

// 预加载的图片映射
const MOODBOARD_PREFACE_MESSAGE = '就是它了～我也觉得这套穿搭特别适合你的风格～我正在从全球智能穿搭库中为你筛选最匹配的单品～💫 每一个选项都经过 AI 造型模型的风格匹配与色彩协调计算🧩 我想确保——你选的，不只是“像”，而是真正属于你的 vibe💃'
const MOODBOARD_TYPING_STATUS_TEXT = '正在比对质地、版型、配色...'
const MOODBOARD_LOADING_IMAGES = Array.from({ length: 9 }, (_, index) => `https://agent-nuva.oss-cn-shanghai.aliyuncs.com/public/agent_svg/${index + 1}.svg`)
// 根据远程图片URL获取服务器图片路径（直接返回服务器完整URL，不走代理）
const getLocalImagePath = (remoteImageUrl) => {
    // 直接返回服务器返回的完整URL，原封不动
    return remoteImageUrl || ''
}
import javaApi from '@/api/javaApi'
import VoiceRecorder from '@/components/VoiceRecorder.vue'
import VoiceMessageBubble from '@/components/VoiceMessageBubble.vue'
import {expiredStorage} from "@/utils/expiredStorage";
import { StartExploreApi } from '@/api/startExplore'
const isOne=ref(true)
const isListRecommendation=ref(false);
// 处理analyzeOutfit响应的函数
const handleAnalyzeOutfitResponse = (raw) => {
    try {
        if (raw) {
            const obj = JSON.parse(raw)
            console.log('监听到analyzeOutfit响应，解析后的对象:', obj)
            console.log('对象中的uploadResult:', obj.value.uploadResult)

            const mess = {
                type: 'ai',
                content: obj.value.uploadResult.data.analysis,
                timestamp: Date.now(),
                scenario:'Text'
            }
            messages.value.push(mess)

            // 显示 isTyping 1秒钟（API响应完成，但还要处理第二条消息）
            isTyping.value = true

            // 1秒后再推送第二条消息
            setTimeout(() => {
                // 处理 products 中的 image URL，使用服务器图片
                const processedProducts = obj.value.uploadResult.data.products.map(product => ({
                    ...product,
                    image: getLocalImagePath(product.image), // 转换为服务器路径格式
                    imageName: product.image.split('/').pop() // 添加 imageName 字段存储文件名
                }))
                console.log('处理后的产品数据:', processedProducts)
                const mess1 = {
                    type: 'ai',
                    content: obj.value.uploadResult.data.choose_device,
                    timestamp: Date.now(),
                    scenario:'editImage',
                    products: processedProducts,
                }
                messages.value.push(mess1)
                isTyping.value = false
                scrollToBottom()
            }, 1000)
        }
    } catch (e) {
        console.error('处理analyzeOutfit响应数据失败:', e)
        // 出错时也要设置isTyping为false
        isTyping.value = false
    }
}

// 检查analyzeOutfit API是否正在进行中的函数
const checkAnalyzeOutfitStatus = () => {
    // 检查是否有analyzeOutfit数据
    const raw = localStorage.getItem('agent-form-step44')
    if (raw) {
        console.log('发现已有analyzeOutfit数据，直接处理')
        handleAnalyzeOutfitResponse(raw)
        return true // 已有数据
    }

    isTyping.value = true
    return false // API正在进行中

}

// 监听analyzeOutfit响应的函数
const setupAnalyzeOutfitListener = () => {
    let hasProcessed = false // 标记是否已经处理过响应
    let timeoutId = null // 超时定时器ID

    // 轮询检查数据变化
    const checkForDataChange = () => {
        if (hasProcessed) return // 如果已经处理过，直接返回

        try {
            const raw = localStorage.getItem('agent-form-step44')

            // 如果有数据且还没有处理过
            if (raw && !hasProcessed) {
                console.log('检测到analyzeOutfit数据，开始处理响应')
                hasProcessed = true // 立即标记为已处理，防止重复

                // 清除超时定时器
                if (timeoutId) {
                    clearTimeout(timeoutId)
                    timeoutId = null
                }

                // 清除等待消息（如果有的话）
                if (messages.value.length > 0 && messages.value[messages.value.length - 1].content === '正在分析您的照片，请稍候...') {
                    messages.value.pop()
                }

                handleAnalyzeOutfitResponse(raw)
            }
        } catch (e) {
            console.error('检查analyzeOutfit数据时出错:', e)
        }
    }

    // 设置超时机制
    timeoutId = setTimeout(() => {
        if (!hasProcessed && isTyping.value) {
            console.log('analyzeOutfit API超时，停止等待')
            isTyping.value = false

            // 添加超时提示消息
            const timeoutMessage = {
                type: 'ai',
                content: '分析超时，请重试或联系客服',
                timestamp: Date.now(),
                scenario: 'Text'
            }
            messages.value.push(timeoutMessage)
            scrollToBottom()
        }
    }, 30000) // 30秒超时
    
    // 每500ms检查一次数据变化
    const intervalId = setInterval(checkForDataChange, 500)
    
    // 返回清理函数
    return () => {
        clearInterval(intervalId)
        if (timeoutId) {
            clearTimeout(timeoutId)
        }
    }
}

onMounted(async () => {
    // 预加载图片
    // await preloadImages()
    // isTyping.value = true
    try {
        /*  console.log(getSavedSize());
          const user=getSavedSize();
          userid.value=user.userid;
          face_image_url.value=process.env.VUE_APP_PROXY_TARGET+user.face_image_url;
          console.log(userid.value,face_image_url.value)*/
        // expiredStorage.setItem('userId', userid.value)
        // 获取并保存拍照上传的API返回结果
      /*  const {userId}= expiredStorage.getItem('user');
        userId.value=userId;*/
        // 检查analyzeOutfit API状态
        const hasData = checkAnalyzeOutfitStatus()

        // 只有在没有数据时才启动监听器
        if (!hasData) {
            isTyping.value = false
            console.log('analyzeOutfit API可能正在进行中，启动监听器等待响应...')
            // 设置analyzeOutfit响应监听器
            const cleanupListener = setupAnalyzeOutfitListener()

            // 在组件卸载时清理监听器
            onUnmounted(() => {
                cleanupListener()
            })
        } else {
            console.log('analyzeOutfit数据已存在，无需启动监听器')
        }
    } catch (e) {
        console.log(e)
        // ignore
    }
    // 初始挂载后滚动到底部（避免首次显示在顶部）
    nextTick(() => scrollToBottom(false))
})
// 响应式数据
const message = ref('')
const fileInput = ref(null)
const messagesContainer = ref(null)
const messages = ref([])
// 新增：用于跟踪 AI 列表中的选中项
const selectedAIIndex = ref(null)
const isTyping = ref(true)
const typingStatusText = ref('')
const activeMoodboardLoadingMessage = ref(null)
let moodboardCarouselTimer = null
const isVoiceMode = ref(false)
const stopMoodboardLoadingCarousel = () => {
    if (moodboardCarouselTimer) {
        clearInterval(moodboardCarouselTimer)
        moodboardCarouselTimer = null
    }
    if (activeMoodboardLoadingMessage.value) {
        activeMoodboardLoadingMessage.value.active = false
        const idx = messages.value.indexOf(activeMoodboardLoadingMessage.value)
        if (idx !== -1) {
            messages.value.splice(idx, 1)
        }
        activeMoodboardLoadingMessage.value = null
    }
}

const startMoodboardLoadingCarousel = () => {
    stopMoodboardLoadingCarousel()
    nextTick(() => scrollToBottom())
    const loadingMessage = {
        type: 'ai',
        timestamp: Date.now(),
        scenario: 'MoodboardLoading',
        images: [...MOODBOARD_LOADING_IMAGES],
        currentIndex: 0,
        active: true
    }
    activeMoodboardLoadingMessage.value = loadingMessage
    messages.value.push(loadingMessage)
    nextTick(() => scrollToBottom())

    moodboardCarouselTimer = setInterval(() => {
        if (!activeMoodboardLoadingMessage.value || !activeMoodboardLoadingMessage.value.active) {
            return
        }
        const msg = activeMoodboardLoadingMessage.value
        msg.currentIndex = (msg.currentIndex + 1) % msg.images.length
    }, 800)
}

const uploadedImage = ref(null)
const voiceUIState = ref('idle') // idle/recording/cancel/stop
const voiceDuration = ref(0)
const isVoiceCall = ref(false) // 标记是否为语音调用
const selectedStyle = ref(null) // 选中的时尚风格索引
const selectedProductIndex = ref(null) // 选中的产品索引
const selectedProductIndex4 = ref(null) // 选中的产品索引
const selectedProduct = ref(null) // 选中的产品信息
const selectedProduct4 = ref(null) // 选中的产品信息

// API返回数据
const apiUploadResult = ref(null) // 存储拍照上传API的返回结果
const touchStartX4 = ref(0) // 触屏开始X坐标
const touchStartY4 = ref(0) // 触屏开始Y坐标
const touchEndX4 = ref(0) // 触屏结束X坐标
const touchEndY4 = ref(0) // 触屏结束Y坐标
const selectedCardIndex = ref(null) // 选中的卡片索引（场景4）
const selectedScenario4Product = ref(null) // 选中的场景4商品索引
const isSelectingStyle = ref(false) // 是否正在选择风格（防重复点击）
const vibeImageUrl = ref(null)//场景4 风格图片
const thisType = ref(null);
const scenario4ImageError = ref(false) // 场景4图片加载错误标记
// 获取已保存的尺码/身材信息（从 step4 的 payload.meta 里读取）

const step2Data = ref({
    title: 'I have generated 4 pics for you, lets have a look. And let me know which one is your favourite one!',
    content: '我为您生成了4个时尚搭配选项，每个都有不同的风格特点：',
    products: []
})
// 场景4数据初始化
const scenario4Data = ref({
    products: [],
    caption: 'I have generated 4 pics for you, lets have a look. And let me know which one is your favourite one!'
    ,
})
// 场景5数据初始化
const step5ata = ref({
    title: "Choose Your Favorite Outfit",
    description: "Select the outfit that best matches your style preference",
    cards: []
})

// 时间格式化函数
const formatTime = (timestamp) => {
    const date = new Date(timestamp)
    return date.toLocaleTimeString('zh-CN', {
        hour: '2-digit',
        minute: '2-digit'
    })
}

// 滚动到底部
const scrollToBottom = (smooth = true) => {
    nextTick(() => {
        if (messagesContainer.value) {
            if (smooth) {
                messagesContainer.value.scrollTo({
                    top: messagesContainer.value.scrollHeight,
                    behavior: 'smooth'
                })
            } else {
                messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight
            }
        }
    })
}
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms))
// 模拟AI回复
// 调用真实的AI后端API
const callAIBackend = async (userText, imageUrl = null) => {
    try {
        console.log('调用后端API，用户输入:', userText, '图片:', imageUrl)
        console.log('当前状态', thisType.value)

        // 根据当前状态和图片URL决定调用哪个API
        let response = null
         if (thisType.value === 'ListRecommendation' && vibeImageUrl.value) {
             response = await ChatApi.sendTextAndImageCheck(userText,null, vibeImageUrl.value)
         }else if (thisType.value === 'editImage' && vibeImageUrl.value){
             // 编辑图片 换风格
             response = await ChatApi.selectStyleOne(userText)
         }else {
             response = await ChatApi.sendTextAndImage(userText, imageUrl)
         }
      console.log('后端API响应:', response)
        let type = response.type
        if (type === null) {
            type = 'text'
        }
        thisType.value = type
        if (type === 'text') {
            if (isOne.value){
                isOne.value=false
                return {
                    type: 'ai',
                    content: response.reply,
                    timestamp: Date.now(),
                    scenario: 'defaultText'
                }
            }
            return {
                type: 'ai',
                content: response.reply,
                timestamp: Date.now(),
                scenario: 'Text'
            }
        } else if (type === 'ListRecommendation') {
        step2Data.value.title = response.reply
          if (!isListRecommendation.value){
            const refreshedResponsePromise = ChatApi.sendTextAndImage(userText, imageUrl)
            //转换text
            for (const look of response.ui.looks) {
              isTyping.value = true
              await delay(8000)
              const value = {
                type: 'ai',
                content: `【 ${look.id} 】`+look.prompt,
                timestamp: Date.now(),
                scenario: 'Text'
              }
              messages.value.push(value)
              scrollToBottom(true)
              isTyping.value = false
            }
            isTyping.value = true
            isListRecommendation.value=true
            const refreshedResponse = await refreshedResponsePromise
            const list = []
            refreshedResponse.ui.looks.forEach(look => {
              list.push({
                id: look.id,
                image: look.image_url.replace('http://8.209.85.186:8001', ''),
                name: look.caption,
                description: look.description,
                subtitle: look.description,
              })
            })
            step2Data.value.products = list
            const existingEditImage4Count = messages.value.filter(msg => msg.scenario === 'editImage4').length
            const appearanceCount = existingEditImage4Count + 1
            // 默认选择（第二次出现时选中最后一张） 选第一张
            const shouldDefaultSelect = appearanceCount === 2||appearanceCount===3 && list && list.length > 0
            const lastIndex = shouldDefaultSelect ? 0 : null
            const defaultSelected = shouldDefaultSelect ? list[lastIndex] : null
            const messageObj = {
              type: 'ai',
              content: refreshedResponse.reply,
              timestamp: Date.now(),
              scenario: 'editImage4',
              appearanceCount: appearanceCount,
              products: list,
              // 当 appearanceCount === 2 时默认选中最后一张并展示大图
              selectedProductIndex4: lastIndex,
              selectedProduct4: defaultSelected,
              collapsed: false,
              confirmed4: false, // 初始化确认状态为 false
              selectionLocked4: false // 初始化锁定状态为 false
            }

            // 在创建消息后立即上传产品图片（异步执行，不阻塞消息返回）
            try {
              uploadProductImages(list, appearanceCount).catch(error => {
                console.error('上传产品图片失败:', error)
              })
            } catch (error) {
              // 确保即使调用出错也不影响消息显示
              console.error('调用上传函数失败:', error)
            }
            return messageObj
          }
          const refreshedResponse = response
            const list = []
            refreshedResponse.ui.looks.forEach(look => {
                list.push({
                    id: look.id,
                    image: look.image_url.replace('http://8.209.85.186:8001', ''),
                    name: look.caption,
                    description: look.description,
                    subtitle: look.description,
                })
            })
            step2Data.value.products = list
            const existingEditImage4Count = messages.value.filter(msg => msg.scenario === 'editImage4').length
            const appearanceCount = existingEditImage4Count + 1
            // 默认选择（第二次出现时选中最后一张） 选第一张
            const shouldDefaultSelect = appearanceCount === 2||appearanceCount===3 && list && list.length > 0
            const lastIndex = shouldDefaultSelect ? 0 : null
            const defaultSelected = shouldDefaultSelect ? list[lastIndex] : null
            const messageObj = {
                type: 'ai',
                content: refreshedResponse.reply,
                timestamp: Date.now(),
                scenario: 'editImage4',
                appearanceCount: appearanceCount,
                products: list,
                // 当 appearanceCount === 2 时默认选中最后一张并展示大图
                selectedProductIndex4: lastIndex,
                selectedProduct4: defaultSelected,
                collapsed: false,
                confirmed4: false, // 初始化确认状态为 false
                selectionLocked4: false // 初始化锁定状态为 false
            }

            // 在创建消息后立即上传产品图片（异步执行，不阻塞消息返回）
            try {
                uploadProductImages(list, appearanceCount).catch(error => {
                    console.error('上传产品图片失败:', error)
                })
            } catch (error) {
                // 确保即使调用出错也不影响消息显示
                console.error('调用上传函数失败:', error)
            }
            return messageObj
        } else if (type === 'ImageWithList') {
            thisType.value = type
            const rawMoodboardUrl = response.ui.moodboard_items.final_moodboard.image_url
            // 转换为代理URL（去掉固定前缀，走代理）
            const proxyMoodboardUrl = rawMoodboardUrl.replace('http://8.209.85.186:8001', '')
            // 取用户 ID 与当前域名
            const stored = expiredStorage.getItem('user') || {}
            const userId = stored.userId || stored.userid || `onboard-Max-${Date.now()}`
            const origin = window.location.origin

            // 背景使用情绪板原图，二维码使用后端生成的图片
            const backgroundImageUrl = proxyMoodboardUrl || rawMoodboardUrl
            let qrImageDataUrl = ''
            try {
                // 调用后端接口获取二维码字节，传递代理URL给后端
                console.log('调用 uploadSingleAndGenerateQR，参数:', { userId, filePath: proxyMoodboardUrl, origin })
                const qrBlob = await javaApi.uploadSingleAndGenerateQR(userId, proxyMoodboardUrl, origin)
                console.log('后端返回二维码，大小:', qrBlob.size)

                // 直接使用后端生成的二维码图片
                qrImageDataUrl = URL.createObjectURL(qrBlob)
            } catch (e) {
                console.warn('二维码合成失败，回退为原图显示:', e)
                qrImageDataUrl = ''
            }
            return {
                type: 'ai',
                content: response.reply,
                image: backgroundImageUrl,
                qrImage: qrImageDataUrl,
                timestamp: Date.now(),
                scenario: 'ImageWithList'
            }

        } else if (type === 'Scenario4Layout') {
            scenario4Data.value.title = response.reply
            const list = []
            response.ui.products.forEach(look => {
                list.push({
                    id: look.product_id,
                    name: look.name,
                    brand: look.brand,
                    price: look.price,
                    image: look.image1_url.replace('http://8.209.85.186:8002', ''),
                })
            })
            scenario4Data.value.products = list

            // 计算当前 editImage4 消息的出现次数
            const existingEditImage4Count = messages.value.filter(msg => msg.scenario === 'editImage4').length
            const appearanceCount = existingEditImage4Count + 1
            const shouldDefaultSelect = appearanceCount === 2 && list && list.length > 0
            const lastIndex = shouldDefaultSelect ? list.length - 1 : null
            const defaultSelected = shouldDefaultSelect ? list[lastIndex] : null

            return {
                type: 'ai',
                content: response.reply,
                timestamp: Date.now(),
                scenario: 'Scenario4Layout',
                selectedProductIndex4: lastIndex, // 第二次默认选中最后一张
                selectedProduct4: defaultSelected, // 第二次默认选中最后一张
                appearanceCount: appearanceCount, // 根据已有消息数量设置出现次数
                clicked: false, // 初始化点击状态
                animating: false, // 初始化动画状态
                collapsed: false, // 初始化收起状态
                products: list
            }
        } else if (type === 'editImage') {
            thisType.value = type
            // 处理产品列表
            const products = response.ui.looks.map(look => ({
                id: look.id,
                image: look.image_url.replace('http://8.209.85.186:8002', ''),
                name: look.caption || look.description,
                description: look.description,
                price: look.price || '0'
            }))

            return {
                type: 'ai',
                content: response.reply,
                timestamp: Date.now(),
                imgUrl: response.ui.looks[0].image_url.replace('http://8.209.85.186:8002', ''),
                scenario: 'editImage',
                products: products, // 添加产品列表
                // 初始化选择状态
                selectedProductIndex: null,
                selectedProduct: null,
                isConfirmed: false,
                selectionLocked: false
            }
        }
        // 将后端响应转换为前端消息格式，并处理可选 payload
        return {
            type: 'ai',
            content: response.reply,
            timestamp: Date.now(),
            scenario: 'text'
        }
        // 同步更新前端状态（若后端返回 payload）
    } catch (error) {
        console.error('调用后端API失败:', error)
        console.error('错误详情:', {
            message: error.message,
            response: error.response,
            status: error.response?.status,
            data: error.response?.data,
            code: error.code,
            name: error.name
        })

        // 更精确地识别网络连接失败或超时
        const isNetworkError = (
            error.message === '网络连接失败' ||
            error.message === 'timeout' ||
            error.message === 'Network Error' ||
            error.message === '网络连接超时' ||
            error.code === 'NETWORK_ERROR' ||
            error.code === 'TIMEOUT' ||
            error.code === 'ECONNABORTED' ||
            error.code === 'ECONNRESET' ||
            error.name === 'NetworkError' ||
            error.name === 'TimeoutError' ||
            error.response?.status >= 500 ||
            error.response?.status === 0
        )

        if (isNetworkError) {
            console.log('网络连接问题（VPN不稳定），不显示错误消息，让用户继续等待')
            // 不返回任何消息，让用户继续等待
            return null
        }
        isTyping.value = true
        // 其他错误才显示错误消息
        console.log('显示错误消息:', error.message)
        return {
            type: 'ai',
            content: `Sorry, I encountered an error while processing your request. Error: ${error.message}. Please try again.`,
            timestamp: Date.now(),
            scenario: 'Text'
        }
    }
}
const callsSlectStyle = async (userText) => {
    try {
        const response = await ChatApi.selectStyle(userText, selectedProduct.value.id)

        // 处理产品列表
        const products = response.ui.looks.map(look => ({
            id: look.id,
            image: look.image_url.replace('http://8.209.85.186:8002', ''),
            name: look.caption || look.description,
            description: look.description,
            price: look.price || '0'
        }))

        const mess = {
            type: 'ai',
            content: response.reply,
            timestamp: Date.now(),
            imgUrl: response.ui.looks[0].image_url.replace('http://8.209.85.186:8002', ''),
            scenario: 'editImage',
            products: products, // 添加产品列表
            // 初始化选择状态
            selectedProductIndex: null,
            selectedProduct: null,
            isConfirmed: false,
            selectionLocked: false
        }
        thisType.value = 'editImage'
        messages.value.push(mess)
        isTyping.value = false
        scrollToBottom(true)
    } catch (error) {
        console.error('调用 selectStyle API 失败:', error)
        isTyping.value = false
        throw error // 重新抛出错误，让调用者处理
    }
}

// 处理语音识别结果
const handleVoiceResult = (voiceData) => {
    console.log('收到语音数据:', voiceData)

    if (voiceData && voiceData.type === 'voice') {
        // 创建语音消息对象（用于显示）
        const voiceMessage = {
            type: 'user',
            content: voiceData.text || '',
            voice: {
                audioUrl: voiceData.audioUrl,
                duration: voiceData.duration,
                blob: voiceData.audioBlob
            },
            timestamp: Date.now()
        }

        // 添加到消息列表
        messages.value.push(voiceMessage)

        // 滚动到底部
        nextTick(() => {
            scrollToBottom()
        })

        // 如果有识别文本，发送给AI
        if (voiceData.text && voiceData.text.trim()) {
            console.log('发送识别文本给AI:', voiceData.text)
            // 设置消息内容并发送
            message.value = voiceData.text.trim()
            sendMessage()
        }
    }
}

// 发送消息
const sendMessage = async () => {
    const text = (message.value || '').trim()
    if (!text && !uploadedImage.value && !selectedProduct.value) return

    // 打印所有选中对象的状态 - 调试用
    console.log('=== 发送消息前的选中状态 ===')
    console.log('选中的时尚风格索引:', selectedStyle.value)
    console.log('选中的商品对象:', selectedProduct.value)
    console.log('选中的商品对象:', messages.value)
    console.log('选中的AI列表项索引:', selectedAIIndex.value)
    console.log('选中的卡片索引:', selectedCardIndex.value)
    // console.log('选中的场景4商品索引:', selectedScenario4Product.value)
    // console.log('场景4选中的商品数据:', scenario4Data.value.selectedProduct)
    console.log('用户输入文本:', text)
    console.log('上传的图片:', uploadedImage.value)
    console.log('=== 选中状态打印结束 ===')

    // 添加用户消息
    let finalText = text
    if (selectedProduct.value && selectedStyle.value !== null) {
        // 统一替换成当前选择
        finalText = (`${message.value}` || '').replace(/^\[Pic\s*\d+\]\s*/i, `[Pic ${selectedStyle.value + 1}] `)
    }
    const userMessage = {
        type: 'user',
        content: finalText || '',
        image: uploadedImage.value,
        timestamp: Date.now()
    }

    messages.value.push(userMessage)
    // scrollToBottom(true)
    // 保存当前输入状态
    const currentText = finalText
    const currentImage = uploadedImage.value
    // 清空输入
    message.value = ''
    uploadedImage.value = null
    if (fileInput.value) {
        fileInput.value.value = ''
    }

    // 选择保留到AI回复后再清空

    // 显示打字指示器
    isTyping.value = true

    // 延迟滚动，确保打字指示器显示
  /*  setTimeout(() => {
        scrollToBottom(true)
    }, 100)*/
    try {
        // 发送普通文本和图片消息
        /* if (selectedProduct.value){
             const aiMessage = await  callsSlectStyle('moodboard', currentImage)
             console.log(aiMessage)
             selectedProduct.value=null
         }*/
        const aiMessage = await callAIBackend(currentText, currentImage)
        if (!aiMessage) return // 如果调用后端API返回null，则不添加任何消息并退出函数
        // 添加真实回复
        // 模拟AI响应延迟
        // 发送普通文本和图片消息
        // AI回复后平滑滚动
        isTyping.value = false
        messages.value.push(aiMessage)
        console.log(aiMessage)

        // 如果是新的editImage4消息，重置上传状态
        if (aiMessage.scenario === 'editImage4'||aiMessage.scenario==='ImageWithList') {
            // hasUploaded.value = false
            // loadedProductFiles.value = []
            setTimeout(() => {
                scrollToBottom(true)
            }, 1000)
        }else {
            scrollToBottom(true)
        }

    } catch (error) {
        console.error('发送消息失败:', error)
        isTyping.value = false

    }

}

// 选择时尚风格
const selectStyle = async (styleIndex, product) => {
    // 如果正在处理请求，则忽略点击
    if (isSelectingStyle.value) {
        console.log('正在处理风格选择请求，忽略重复点击')
        return
    }
    console.log(product)
    isSelectingStyle.value = true
    selectedStyle.value = styleIndex
    selectedProduct.value = product
    console.log('Selected style (pending):', styleIndex, product?.name)
    // 将标识写入输入框开头，便于用户看到
    // 移除旧的 [Pic x] 前缀，保持唯一
    message.value = (message.value || '').replace(/^\[Pic\s*\d+\]\s*/i, '')
    // message.value = prefix + message.value
    scrollToBottom(true)
    isTyping.value = true

    try {
        vibeImageUrl.value = product?.image
        await callsSlectStyle(null, uploadedImage.value)
    } catch (error) {
        console.error('选择风格时出错:', error)
        // 发生错误时重置状态
        isTyping.value = false
    } finally {
        // 无论成功还是失败，都要重置选择状态
        isSelectingStyle.value = false
    }
}

// 产品选择相关方法
const selectionLocked = ref(false)
const isConfirmed = ref(false) // 是否已点击"就它了"
const selectProduct = (index, msg) => {
    // 仅当发送后锁定，才禁止再次选择
    if (msg && msg.selectionLocked) return

    // 更新消息对象的选择状态
    if (msg) {
        msg.selectedProductIndex = index
        if (msg.products && msg.products[index]) {
            msg.selectedProduct = msg.products[index]
        }
    }

    scrollToBottom(true)
}
const selectProduct4 = (index, product, msg) => {
    // 发送后锁定，禁止再次选择
    if (msg && msg.selectionLocked4) {
        console.log('已确认选择，无法再次选择')
        return
    }
    // 为当前消息设置选中状态
    if (msg) {
        msg.selectedProductIndex4 = index
        msg.selectedProduct4 = product
    }
    // 等待DOM更新后再查找大图元素
    nextTick(() => {
        // 查找大图元素
        // const largeImage = document.querySelector('.editimage4-large-image')
        setTimeout(() => {
            scrollToBottom(true)
        }, 500)
    })

    // 保持全局状态用于其他功能
    selectedProductIndex4.value = index
    selectedProduct4.value = product
    console.log('Selected product for message:', product)
}

const prevImage4 = (msg) => {
    // 如果已锁定，禁止切换
    if (msg && msg.selectionLocked4) {
        console.log('已确认选择，无法切换图片')
        return
    }
    if (msg && msg.selectedProductIndex4 > 0) {
        const newIndex = msg.selectedProductIndex4 - 1
        selectProduct4(newIndex, msg.products[newIndex], msg)
    }
}

const nextImage4 = (msg) => {
    console.log('nextImage4 called for message:', msg)
    console.log('msg.selectedProductIndex4:', msg?.selectedProductIndex4)
    console.log('products length:', msg?.products?.length)

    // 如果已锁定，禁止切换
    if (msg && msg.selectionLocked4) {
        console.log('已确认选择，无法切换图片')
        return
    }

    if (msg && msg.products && msg.selectedProductIndex4 !== null && msg.selectedProductIndex4 >= 0 && msg.selectedProductIndex4 < msg.products.length - 1) {
        const newIndex = msg.selectedProductIndex4 + 1
        console.log('Calling selectProduct4 with index:', newIndex)
        selectProduct4(newIndex, msg.products[newIndex], msg)
    } else {
        console.log('Condition not met for nextImage4')
    }
}

// 触屏滑动处理函数
const handleTouchStart4 = (e, msg) => {
    touchStartX4.value = e.touches[0].clientX
    touchStartY4.value = e.touches[0].clientY
    // 将当前消息存储到事件目标上，以便在滑动结束时使用
    e.currentTarget._currentMsg = msg
}

const handleTouchMove4 = (e) => {
    // 阻止默认滚动行为
    e.preventDefault()
}

const handleTouchEnd4 = (e) => {
    touchEndX4.value = e.changedTouches[0].clientX
    touchEndY4.value = e.changedTouches[0].clientY
    const msg = e.currentTarget._currentMsg
    handleSwipe4(msg)
}

const handleSwipe4 = (msg) => {
    const deltaX = touchEndX4.value - touchStartX4.value
    const deltaY = touchEndY4.value - touchStartY4.value

    // 确保是水平滑动（水平距离大于垂直距离）
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
        if (deltaX > 0) {
            // 向右滑动 - 上一张
            console.log('Swipe right - previous image')
            prevImage4(msg)
        } else {
            // 向左滑动 - 下一张
            console.log('Swipe left - next image')
            nextImage4(msg)
        }
    }
}

const confirmSelection = async (msg) => {
    console.log(msg?.selectedProduct)

    // 标记已确认选择
    if (msg) {
        msg.selectionLocked = true
        msg.isConfirmed = true
    }

    // 显示打字指示器
    isTyping.value = true
    scrollToBottom(true)
    let req = {
        'device_url': msg.selectedProduct.image,
        ui_event: "first_hello",
        'text': '开始造型'
    }
    console.log(req)
    let response = await ChatApi.sendMessage(req)
    console.log(response)
    // 等待1秒后显示Text1内容
    setTimeout(() => {
        const productName = msg?.selectedProduct?.name || '单品'
        const aiMessage = {
            type: 'ai',
            content: '', // 保留content字段以兼容
            timestamp: Date.now(),
            scenario: 'Text1',
            selectedProduct: msg?.selectedProduct, // 传递选中的产品信息
            text1Opening: `哦～好眼光！😎 这个${productName}马上会成为你造型的C位亮点`,
            text1Prompt: '那现在告诉我你的需求吧！比如：',
            text1Occasion: '音乐节 / 出差 / 约会 / 度假 / 晚宴',
            text1Style: '飒 / 极简 / 街头 / 优雅 / 时尚 / 未来感',
            text1Color: '黑白灰 / 大地色系 / 同色系 / 撞色 / 鲜艳 / 素净',
            text1Closing: '场合 + 风格，我马上为你调出专属 vibe✨～'
        }

        isTyping.value = false
        messages.value.push(aiMessage)
        scrollToBottom(true)
    }, 1000) // 1秒延迟
}

// Text场景确认按钮处理
const handleTextConfirm = async (msg) => {
    if (!msg) return

    // 隐藏按钮
    msg.textConfirmed = true

    // 添加用户消息
    const userMessage = {
        type: 'user',
        content: '开始设计',
        timestamp: Date.now()
    }
    messages.value.push(userMessage)

    // 保存当前输入状态
    const currentText = '开始设计'
    const currentImage = null

    // 显示打字指示器
    isTyping.value = true

    // 延迟滚动，确保打字指示器显示
    setTimeout(() => {
        scrollToBottom(true)
    }, 100)

    try {
        // 等待startExplore响应完成并确保数据已保存
        console.log('等待startExplore请求完成...')
        await StartExploreApi.waitForCurrentRequest()
        console.log('startExplore请求已完成，开始调用callAIBackend')

        // 读取用户数据（此时应该已经保存完成）
        const userData = expiredStorage.getItem('user')
        console.log('从存储读取的完整user数据:', userData)

        if (!userData) {
            console.warn('⚠️ 未找到user数据')
        } else {
            const {userId, face_image_url} = userData
            console.log('userId:', userId)
            console.log('face_image_url:', face_image_url)

            if (!face_image_url) {
                console.warn('⚠️ face_image_url 为空，可能数据保存失败')
            }
        }

        // 调用后端API，参考 sendMessage 方法
        const aiMessage = await callAIBackend(currentText, currentImage)
        if (!aiMessage) return // 如果调用后端API返回null，则不添加任何消息并退出函数

        // 添加AI回复
        isTyping.value = false
        messages.value.push(aiMessage)
        console.log(aiMessage)

        // 如果是新的editImage4消息，重置上传状态
        if (aiMessage.scenario === 'editImage4' || aiMessage.scenario === 'ImageWithList') {
            setTimeout(() => {
                scrollToBottom(true)
            }, 1000)
        } else {
            scrollToBottom(true)
        }
    } catch (error) {
        console.error('发送消息失败:', error)
        isTyping.value = false
    }
}
const replenish = async () => {
    // 添加用户消息
    const userMessage = {
        type: 'user',
        content: '还要补充',
        timestamp: Date.now()
    }
    messages.value.push(userMessage)
    // 显示打字指示器
    // 延迟滚动，确保打字指示器显示
    setTimeout(() => {
        scrollToBottom(true)
    }, 100)
}

// 注释掉的旧代码已移除，功能已迁移到 handleText1Confirm

const confirmSelection1 = async (id, msg) => {
    console.log('confirmSelection1 - 就它! Next 点击', id, msg)
    isTyping.value = true
    scrollToBottom()

    // 设置点击状态和动画状态
    if (msg) {
        // 锁定本条消息的选择
        msg.selectionLocked4 = true
        msg.confirmed4 = true // 标记为已确认，用于显示样式
        msg.clicked = true
        msg.animating = true
        msg.collapsed = true // 收起大图显示和隐藏按钮

        // 播放放大缩小动画
        setTimeout(() => {
            msg.animating = false
        }, 1000) // 1秒后停止动画
    }

    try {
        const response = await ChatApi.selectStyle(null, id)
        // const response = null
        console.log(response)
        const data = response
        console.log('产品选择响应:', data)

        // 添加AI回复
      /*  const aiMessage = {
            type: 'ai',
            content: data.reply,
            timestamp: Date.now(),
            scenario: 'Text'
        }*/
        msg.supplement = data.reply
        // msg.supplement = '哦哦，这件单品真是我的心头好！😍 接下来，告诉我你想要在哪个场合炫酷出场：音乐节、出差、约会、度假放松...? 或者加点风格调味料：比如极简、街头、优雅、未来感... 或者告诉我你偏爱的颜色～'
        isTyping.value = false
        scrollToBottom()
        // messages.value.push(aiMessage)

        // 重置选择状态
        selectedProductIndex.value = null
        selectedProduct.value = null

        // 滚动到底部
        nextTick(() => {
            scrollToBottom()
        })

    } catch (error) {
        console.error('产品选择失败:', error)
        isTyping.value = false
    }
}
const confirmMoodboard = async (id, msg) => {
    console.log('confirmMoodboard - Moodboard 点击', id, msg)
    isTyping.value = true
    typingStatusText.value = ''
    scrollToBottom()
    // 设置点击状态和动画状态
    if (msg) {
        msg.selectionLocked4 = true // 锁定选择，禁止再次选择
        msg.confirmed4 = true // 标记为已确认，用于显示样式
        msg.clicked = true
        msg.animating = true
        msg.collapsed = true // 收起大图显示和隐藏按钮

        // 播放放大缩小动画
        setTimeout(() => {
            msg.animating = false
        }, 1000) // 1秒后停止动画
    }

    let hasFinalized = false
    let canShowFinalResponse = false
    let responseData = null

    const finalizeIfPossible = () => {
        if (hasFinalized) return
        if (!canShowFinalResponse || !responseData) return
        hasFinalized = true
        stopMoodboardLoadingCarousel()
        const res = {
            type: 'ai',
            content: responseData.reply,
            image: responseData.image,
            qrImage: responseData.qrImage,
            timestamp: Date.now(),
            scenario: 'ImageWithList'
        }
        messages.value.push(res)
        typingStatusText.value = ''
        isTyping.value = false
        nextTick(() => scrollToBottom(true))
    }

    const handleError = (error) => {
        if (hasFinalized) return
        console.error('生成 Moodboard 失败:', error)
        hasFinalized = true
        typingStatusText.value = ''
        isTyping.value = false
        stopMoodboardLoadingCarousel()
    }

    try {
        const requestPromise = ChatApi.moodboardSend(null, id)
        requestPromise.then(async response =>  {
            if (hasFinalized) return

            const type = response?.type ?? null
            if (type !== null) {
                thisType.value = type
            }

            const rawMoodboardUrl = response?.ui?.moodboard_items?.final_moodboard?.image_url || ''
            let proxyMoodboardUrl = rawMoodboardUrl
            responseData = {
                reply: response?.reply || '',
                image: proxyMoodboardUrl || rawMoodboardUrl,
                qrImage: ''
            }
            if (msg) {
                msg.supplement = responseData.reply
            }
            if (proxyMoodboardUrl) {
                const stored = expiredStorage.getItem('user') || {}
                const userId = stored.userId || stored.userid || `onboard-Max-${Date.now()}`
                const origin = window.location.origin

                try {
                    console.log('调用 uploadSingleAndGenerateQR，参数:', { userId, filePath: proxyMoodboardUrl, origin })
                    const qrBlob = await javaApi.uploadSingleAndGenerateQR(userId, proxyMoodboardUrl, origin)
                    console.log('后端返回二维码，大小:', qrBlob.size)

                    responseData.qrImage = URL.createObjectURL(qrBlob)
                } catch (e) {
                    console.warn('二维码合成失败，回退为原图显示:', e)
                    responseData.qrImage = ''
                    responseData.image = proxyMoodboardUrl || rawMoodboardUrl
                }
            }
            finalizeIfPossible()
        }).catch(handleError)
    } catch (error) {
        handleError(error)
        return
    }

    setTimeout(() => {
        if (hasFinalized) return
        isTyping.value = false
        const introMessage = {
            type: 'ai',
            content: MOODBOARD_PREFACE_MESSAGE,
            timestamp: Date.now(),
            scenario: 'Text'
        }
        messages.value.push(introMessage)
        nextTick(() => scrollToBottom())

        typingStatusText.value = MOODBOARD_TYPING_STATUS_TEXT
        isTyping.value = true

        setTimeout(() => {
            if (hasFinalized) return
            isTyping.value = false
            typingStatusText.value = ''
            startMoodboardLoadingCarousel()
            canShowFinalResponse = true
            finalizeIfPossible()
        }, 5000)
    }, 3000)
}

onUnmounted(() => {
    stopMoodboardLoadingCarousel()
})

// ==================== editImage4 场景专用 - 图片加载处理 ====================
// 该功能仅用于 editImage4 场景中的产品图片网格加载
const loadedProductFiles = ref([]) // 存储已加载的图片文件
const hasUploaded = ref(false) // 上传状态标志，确保只上传一次
const imageLoadStates = ref(new Map()) // 跟踪每张图片的加载状态
const imageLoadPromises = ref(new Map()) // 跟踪图片加载Promise

// 上传产品图片到后端（在 messageObj 创建后立即调用）
const uploadProductImages = async (products, appearanceCount) => {
    try {
        console.log(`开始下载并上传产品图片 (appearanceCount: ${appearanceCount}), 总数: ${products.length}`)

        // 根据 appearanceCount 决定上传哪些图片
        let productsToUpload = []
        if (appearanceCount === 3 || appearanceCount === 2) {
            // 第二次和第三次：只上传第一张图片
            productsToUpload = products.slice(0, 1)
        } else if (appearanceCount === 1) {
            // 第一次：上传所有图片
            productsToUpload = products
        }

        if (productsToUpload.length === 0) {
            console.log('没有需要上传的图片')
            return
        }

        console.log(`将上传 ${productsToUpload.length} 张图片`)

        const imagePaths = productsToUpload
            .map(product => product.image)
            .filter(path => typeof path === 'string' && path.trim() !== '')

        if (imagePaths.length === 0) {
            console.error('未找到可用的图片路径')
            return
        }

        console.log(`收集到 ${imagePaths.length} 条图片路径，开始上传到后端`)

        // 调用 uploadImages 上传到后端
        const uploadResult = await javaApi.uploadImages(imagePaths)
        console.log('产品图片上传成功:', uploadResult)

        return uploadResult
    } catch (error) {
        console.error('上传产品图片过程失败:', error)
        throw error
    }
}

// editImage4 专用：处理产品图片加载完成事件（仅在 line 100 的 editImage4 网格中使用）
// ==================== editImage4 场景专用代码结束 ====================

// 检查图片加载状态

const skipSelection = async () => {
    try {

        // 添加用户消息
        const userMessage = {
            type: 'ai',
            content: '没有符合你vibe的单品？没关系，时尚没有规则嘛😉 那我们直接进入造型灵感环节吧～\n' +
                '\n' +
                '那现在告诉我\n' +
                '你要在哪个场合炫酷出场：音乐节、出差、约会、度假放松...? 再来加点风格调味料：比如 极简、街头、优雅、未来感...\n' +
                '或者告诉我你 偏爱的颜色～ \n' +
                '场合 + 风格 = 独家造型秘方，交给我来调配～',
            timestamp: Date.now(),
            scenario: 'Text',
        }
        messages.value.push(userMessage)


        // 重置选择状态
        selectedProductIndex.value = null
        selectedProduct.value = null

        // 滚动到底部
        nextTick(() => {
            scrollToBottom()
        })

    } catch (error) {
        console.error('跳过选择失败:', error)
    }
}

// 选择 AI 列表项的处理（用于右侧框架的三项选择高亮）
const selectAIItem = (idx) => {
    selectedAIIndex.value = idx
    // 找到当前场景3的消息并设置selectedProduct
    const currentMessage = messages.value.find(msg => msg.type === 'ai' && msg.scenario === 'ImageWithList')
    if (currentMessage && currentMessage.items && currentMessage.items[idx]) {
        selectedProduct.value = {
            name: currentMessage.items[idx].name,
            image: currentMessage.items[idx].image,
            price: currentMessage.items[idx].price
        }
    }
}
// 场景4：选择商品
const selectScenario4Product = (productIndex, product, msg) => {
    selectedScenario4Product.value = product
    scenario4ImageError.value = false
    // 将选中状态保存到当前消息作用域
    if (msg) {
        msg.selectedProduct = {
            id: product.id,
            name: product.name,
            brand: product.brand,
            price: product.price,
            code: product.code,
            color: product.color,
            composition: product.composition,
            image: product.image
        }
    }
    console.log('Selected scenario4 product by id:', product.id, product.name)
}

// 场景4图片加载错误处理
const onScenario4ImgError = () => {
    scenario4ImageError.value = true
    console.log('场景4图片加载失败，隐藏图片')
}

// 触发试穿功能
const triggerScenario5 = async () => {
    // 检查是否有选中的产品
    if (selectedScenario4Product.value === null) {
        console.error('没有选中的产品，无法进行试穿')
        return
    }

    // 显示打字指示器
    isTyping.value = true
    scrollToBottom(true)
    try {
        // 获取选中的产品信息
        const selectedProduct = selectedScenario4Product.value
        console.log('开始试穿，选中产品:', selectedProduct)

        // 调用try-on API
        const response = await ChatApi.tryOnOutfit(
            selectedProduct.id,
            selectedProduct.image
        )
        // 调用try-on API
        console.log('试穿API响应:', response)
        const scenario5Reply = {
            type: 'ai',
            scenario: 'Step5Grid',
            caption: response.reply,
            timestamp: Date.now()
        }
        const ui = {
            cards: [{
                image: response.ui.moodboard_items.try_on_result.image_url.replace('http://8.209.85.186:8002', '')
            }]
        }
        step5ata.value = ui
        // 转换响应为前端消息格式
        // const aiMessage = ChatApi.convertBackendResponseToMessage(response)
        // 添加AI回复
        messages.value.push(scenario5Reply)
        // 滚动到底部
    } catch (error) {
        console.error('试穿失败:', error)
        isTyping.value = false

        // 显示错误消息
        const errorMessage = {
            type: 'ai',
            content: '抱歉，试穿功能暂时不可用，请稍后再试。',
            timestamp: Date.now(),
            scenario: 'Text'
        }
        messages.value.push(errorMessage)

    } finally {
        isTyping.value = false
        scrollToBottom(true)

    }
}

</script>

<style scoped>
.dialog-page {
    position: relative;
    color: #fff;
    display: flex;
    flex-direction: column;
    width: 100%;
    /*max-width: 750px;*/
    margin: 0 auto;
    height: 100%;
    /*min-height: 500px; !* 增加高度 *!*/
    /*height: 500px; !* 固定高度，防止输入后高度变化 *!*/
    overflow: visible; /* 允许输入框显示在容器外部 */
}

.bg-gradient {
    display: none; /* 移除背景渐变 */
}

/* 页面标题 */
.page-header {
    padding: 15px 20px 10px; /* 减少上边距 */
    text-align: center;
}

.page-title {
    color: rgba(255, 255, 255, 0.95);
    font-size: 32px;
    font-weight: 400;
    margin: 0;
    letter-spacing: 0.8px;
    line-height: 1.2;
}

.hero {
    padding: 10px 20px; /* 减少上下padding */
    width: 100%;
}

.hero .subtle {
    opacity: .8;
    font-size: 14px;
    margin-top: 8px;
    margin-bottom: 0;
}

/* 初始消息特殊样式 */
.initial-message {
    margin-bottom: 0;
}

.initial-message .message-content {
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.15);
}

/* 消息容器 */
.messages-container {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden; /* 禁止左右滚动，仅保留上下滚动 */
    padding: 10px 20px; /* 减少上下padding */
    /* 默认按视口高度自适应，避免在普通屏过长 */
    max-height: calc(100vh - 80px);
    min-height: calc(100vh - 80px);
}

/* 超大屏（如立体大屏）启用固定2050px的展示高度 */
@media (min-width: 2560px), (min-height: 1600px) {
    .messages-container {
        max-height: calc(2050px - 80px); /* 给更多空间给消息显示，因为输入框在外部 */
        min-height: 2050px; /* 相应增加最小高度 */
    }
}

.messages {
    width: 100%;
    text-align: left;
}

/* 消息基础样式 */
.message {
    margin-bottom: 20px;
    animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* 用户消息样式 */
.user-message {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.user-message .message-content {
    /*background: #ABFF66;*/
    color: #262626;
    padding: 12px 16px;
    border-radius: 18px 18px 4px 18px;
    max-width: 70%;
    /*box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);*/
}

/* 用户消息文本换行与长词断行 */
.user-message .message-content p {
    margin: 0;
    white-space: pre-wrap; /* 保留换行并自动换行 */
    word-break: break-word; /* 超长单词/连续字符断行 */
    overflow-wrap: anywhere; /* 进一步保证断行 */
}

.user-message .message-image {
    max-width: 200px;
    border-radius: 8px;
    margin-top: 8px;
    margin-bottom: 0;
}

.user-message .message-time {
    font-size: 11px;
    opacity: 0.7;
    margin-top: 4px;
    margin-right: 8px;
}

/* AI消息样式 */
.ai-message {
    margin-top: 2%;
    margin-left: -1%;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    justify-content: flex-start; /* 整体靠左 */
    margin-right: 4%;
}

.ai-image-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: flex-start;
    padding-left: 12px;
}

.ai-image-caption.top {
    margin: 0 0 6px 0;
}

.image-with-list {
    display: grid;
    grid-template-columns: 140px 1fr;
    gap: 12px;
    align-items: stretch;
    background: rgba(255, 255, 255, 0.5);
    outline: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 16px;
    padding: 10px;
    margin: 0;
    min-height: 280px;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
}

.image-frame-area {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr;
    gap: 8px;
    padding: 12px;
    /*background: rgba(255, 255, 255, 0.08);*/
    /*border-radius: 16px;*/
    /*backdrop-filter: blur(8px);*/
    /*border: 1px solid rgba(255, 255, 255, 0.15);*/
}

.ai-triangle .ai-item-frame {
    width: 100%;
    height: 100%;
    min-height: 160px;
}

.ai-item-frame {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 10px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.1);
    position: relative;
    min-height: 160px;
    transition: all 0.3s ease;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0.15);
    width: 100%;
}

.ai-item-frame-three {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 10px;
    border-radius: 12px;
    /*background: rgba(255, 255, 255, 0.1);*/
    position: relative;
    min-height: 160px;
    transition: all 0.3s ease;
    cursor: pointer;
    /*border: 1px solid rgba(255, 255, 255, 0.15);*/
    width: 100%;
}

.ai-item-frame-three:hover {
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.2);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.ai-item-frame-three.selected {
    background: rgba(76, 175, 80, 0.15);
    border: 2px solid #ABFF66;
    /*box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.3), 0 6px 20px rgba(76, 175, 80, 0.4);*/
    /*transform: translateY(-2px);*/
    /*animation: selectedPulse 2s ease-in-out infinite;*/
}

.ai-item-frame-three.selected .ai-item-title {
    color: #4CAF50;
    font-weight: 700;
}

.ai-item-frame-three.selected .ai-item-number {
    color: #4CAF50;
    font-weight: 700;
}

.ai-item-frame-three.selected .ai-item-price {
    background: rgba(76, 175, 80, 0.8);
    color: #fff;
}

.ai-item-frame-three.selected .ai-item-heart {
    color: #ff6b6b;
}


.ai-item-frame.selected .ai-item-frame-name {
    color: #4CAF50;
    font-weight: 700;
}

.ai-item-frame.selected .ai-item-price {
    background: rgba(76, 175, 80, 0.8);
    border-color: rgba(76, 175, 80, 0.9);
    color: #fff;
}

.ai-item-frame.selected .ai-item-heart {
    color: #ff6b6b;
}

.ai-item-frame.selected .ai-item-frame-thumb {
    border: 2px solid #ABFF66;
    box-shadow: 0 0 0 1px rgba(76, 175, 80, 0.3);
}

.ai-item-frame.selected .ai-item-index-overlay {
    background: #4CAF50;
    color: #fff;
    box-shadow: 0 2px 8px rgba(76, 175, 80, 0.4);
}

/* 选中状态的脉冲动画 */
@keyframes selectedPulse {
    0% {
        box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.3), 0 6px 20px rgba(76, 175, 80, 0.4);
    }
    50% {
        box-shadow: 0 0 0 4px rgba(76, 175, 80, 0.2), 0 6px 20px rgba(76, 175, 80, 0.6);
    }
    100% {
        box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.3), 0 6px 20px rgba(76, 175, 80, 0.4);
    }
}

.ai-item-frame.selected {
    animation: selectedPulse 2s ease-in-out infinite;
}

.ai-item-frame-thumb {
    width: 100%;
    height: auto;
    max-height: 120px; /* 自适应最大高度，避免被裁切 */
    object-fit: contain;
    border-radius: 10px;
    display: block;
    transition: transform 0.3s ease;
}

.ai-item-frame:hover .ai-item-frame-thumb {
    transform: scale(1.05);
}

.ai-item-index {
    display: none;
}

/* 移除原来的序号覆盖层，现在使用新的头部布局 */

.ai-item-frame-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    width: 100%;
}

.ai-item-frame-name {
    font-size: 12px;
    color: #fff;
    margin: 0;
    font-weight: 600;
    text-align: center;
    line-height: 1.3;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.ai-item-frame-badges {
    display: flex;
    gap: 6px;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.ai-item-price {
    background: #000000;
    border: none;
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    color: #ffffff;
    white-space: nowrap;
}

.ai-item-heart {
    width: 18px;
    height: 18px;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #000000;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.5;
}

.ai-item-heart:hover {
    color: #ff6b6b;
    transform: scale(1.1);
}

.ai-item-heart.liked {
    color: #ff6b6b;
}

.ai-reply-image {
    width: 100%;
    height: 100%;
    max-height: none;
    object-fit: cover;
    border-radius: 8px;
    display: block;
}

.ai-message-width {
    width: 80%;
}

.ai-image-caption {
    margin: 8px 0 0 0;
    font-size: 13px;
    opacity: 0.9;
}

/* 简单的场景标识徽标 */
.message.ai::before {
    content: attr(data-scenario);
    position: absolute;
    top: -14px;
    left: 40px;
    font-size: 10px;
    opacity: 0.7;
}

.ai-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: linear-gradient(135deg, #2196F3, #1976D2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
    overflow: hidden;
}

.ai-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
}

.ai-message .message-content {
    background: rgba(60, 60, 80, 0.8);
    backdrop-filter: blur(15px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    padding: 16px 20px;
    border-radius: 16px;
    max-width: 80%;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    color: rgba(255, 255, 255, 0.95);
    line-height: 1.6;
}

/* 场景4专用的消息内容样式 */
.message.ai[data-scenario="Scenario4Layout"] .message-content {
    padding-top: 8px;
}

/* AI回复部分样式 */
.ai-sections {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    padding-left: 12px; /* 与输入框保持固定左边距 */
}

/* AI回复部分样式 */
.ai-sections-init {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-left: 12px; /* 与输入框保持固定左边距 */
}

.ai-section {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding: 0 12px 16px 0; /* 去掉左侧内边距，与输入框左边对齐 */
}

.ai-section:last-child {
    border-bottom: none;
    padding-bottom: 0;
}

.section-title {
    /*color: #4CAF50;*/
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 8px 0; /* 与内容左边对齐 */
    /*white-space: nowrap;*/
    overflow: hidden;
    text-overflow: ellipsis;
}

.section-title-init {
    /*color: #4CAF50;*/
    font-size: 14px;
    margin: 0 0 8px 0; /* 与内容左边对齐 */
    /*white-space: nowrap;*/
    overflow: hidden;
    text-overflow: ellipsis;
}

.section-content {
    margin: 0 0 12px 0;
    opacity: 0.9;
    line-height: 1.5;
    font-size: 13px;
}

/* 产品网格样式 */
.products-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px; /* 稍微减少间距，为更大的图片留出空间 */
    margin-top: 12px;
    padding: 0; /* 去掉左右内边距，使网格与输入框对齐 */
    align-items: start; /* 确保卡片顶部对齐 */
}

/* 产品网格样式 */
.products-grid-init {
    /* 可调参数：修改下面两个变量即可调整图片尺寸与比例 */
    --init-card-width: 114px; /* 默认宽度，可按需调整 */
    --init-card-height: calc(var(--init-card-width) * 1.333); /* 高度=宽度*1.333 */

    display: grid;
    grid-template-columns: repeat(6, var(--init-card-width));
    gap: 24px;
    margin-top: 12px;
    padding: 0; /* 去掉左右内边距，使网格与输入框对齐 */
    justify-content: center;
}

.product-card-init.selected .init-index-badge {
    color: #b8ff6b;
}


.product-card {
    background: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
    transition: none;
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%; /* 确保卡片占满网格高度 */
    /*overflow: hidden;*/
}

.product-card:active {
    transform: none;
}

.product-card:hover {
    transform: none;
}

/* 选中状态样式 */
.product-card.selected {
    transform: none;
}

.product-card.selected:hover {
    box-shadow: none;
}

/* 禁用状态样式 */
.product-card.disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
}

/* 选中动画 */
@keyframes selectedPulse {
    0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7);
    }
    50% {
        transform: scale(1.05);
        box-shadow: 0 0 0 8px rgba(76, 175, 80, 0.3);
    }
    100% {
        transform: scale(1.02);
        box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
    }
}

.product-image {
    width: 100%;
    height: 240px; /* 增加高度以显示更多内容 */
    object-fit: cover; /* 改为cover确保图片填满容器，保持比例 */
    object-position: center center; /* 居中显示 */
    border-radius: 8px;
    margin-bottom: 6px;
    background: rgba(255, 255, 255, 0.04);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
    transition: transform 0.25s ease, box-shadow 0.25s ease;
}

/* 选中时仅给图片加高亮边框 */
.product-card.selected .product-image {
    outline: 3px solid #a6f55d;
    outline-offset: -3px;
}

.product-card:hover .product-image {
    transform: translateY(-2px) scale(1.01);
    box-shadow: 0 10px 22px rgba(0, 0, 0, 0.22);
}

.product-info {
    text-align: left;
    display: grid;
    grid-template-columns: 22px 1fr; /* 左边数字，右边文字 */
    align-items: start;
    gap: 6px;
    flex: 1; /* 让信息区域占据剩余空间 */
    margin-top: auto; /* 推到底部 */
}

.product-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 42px; /* 确保容器有最小高度 */
}

.card-index-inline {
    width: auto;
    height: auto;
    color: rgba(255, 255, 255, 0.9);
    font-size: 34px;
    font-weight: 800;
    line-height: 1;
    margin-top: 2px;
}

.card-index-inline.active {
    color: #a6f55d;
}

/* 选中时文本颜色与权重 */
.product-card.selected .product-title-primary,
.product-card.selected .product-title-secondary {
    color: #a6f55d;
    font-weight: 700;
}

.product-title-primary {
    font-size: 11px;
    margin: 0;
    color: #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-height: 14px; /* 确保最小高度一致 */
    line-height: 1.51;
}

.product-title-secondary {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.85);
    margin: 0;
    line-height: 1.2;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    max-height: 2.4em; /* 约两行的高度上限 */
    min-height: 12px; /* 确保最小高度一致 */
}

.card-index {
    position: absolute;
    left: 6px;
    bottom: 6px;
    width: 18px;
    height: 18px;
    border-radius: 3px;
    background: rgba(255, 255, 255, 0.9);
    color: #000;
    font-size: 12px;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* 选中指示器样式 */
.selection-indicator {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 20px;
    height: 20px;
    background: #4CAF50;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: bold;
    animation: checkmarkPop 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    box-shadow: 0 2px 8px rgba(76, 175, 80, 0.4);
}

@keyframes checkmarkPop {
    0% {
        transform: scale(0) rotate(-180deg);
        opacity: 0;
    }
    50% {
        transform: scale(1.3) rotate(-90deg);
        opacity: 0.8;
    }
    100% {
        transform: scale(1) rotate(0deg);
        opacity: 1;
    }
}

/* 建议列表样式 */
.suggestions-list {
    margin: 12px 0 0 0;
    padding-left: 0;
    list-style: none;
}

.suggestions-list li {
    position: relative;
    padding: 8px 0 8px 20px;
    opacity: 0.9;
    line-height: 1.4;
    font-size: 13px;
}

.suggestions-list li:before {
    content: "✓";
    position: absolute;
    left: 0;
    color: #4CAF50;
    font-weight: bold;
}

/* 简单回复样式 */
.ai-text-container {
    margin: 0;
    padding: 16px 12px;
    text-align: left;
    width: 100%;
    backdrop-filter: blur(15px);
    color: rgba(255, 255, 255, 0.95);
    line-height: 1.6;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 16px;
    border: none;
    position: relative;
}

.ai-text-container::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg,
    rgba(255, 255, 255, 1),
    rgba(204, 204, 204, 0.8),
    rgba(204, 204, 204, 0.4),
    rgba(204, 204, 204, 0.4),
    rgba(204, 204, 204, 0.8),
    rgba(255, 255, 255, 0.9));
    border-radius: 16px;
    padding: 1px;
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: xor;
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    z-index: -1;
}

.slider-image::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg,
    rgba(255, 255, 255, 1),
    rgba(204, 204, 204, 0.8),
    rgba(204, 204, 204, 0.4),
    rgba(204, 204, 204, 0.4),
    rgba(204, 204, 204, 0.8),
    rgba(255, 255, 255, 0.9));
    border-radius: 16px;
    padding: 1px;
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: xor;
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    z-index: -1;
}
.slider-image-item::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg,
    rgba(255, 255, 255, 1),
    rgba(204, 204, 204, 0.8),
    rgba(204, 204, 204, 0.4),
    rgba(204, 204, 204, 0.4),
    rgba(204, 204, 204, 0.8),
    rgba(255, 255, 255, 0.9));
    border-radius: 16px;
    padding: 1px;
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: xor;
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    z-index: -1;
}

/* 图片滑动容器样式 */
.image-slider-container {
    margin-top: 16px;
    width: 100%;
}

.image-slider {
    display: flex;
    overflow-x: auto;
    gap: 22px;
    padding: 8px 16px; /* 增加左右内边距，防止边框被裁剪 */
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.image-slider::-webkit-scrollbar {
    display: none;
}

.slider-image-item {
    opacity: 1;
    flex-shrink: 0;
    width: 250px; /* 增加宽度 */
    height: 250px;
    border-radius: 12px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.1);
    /*border: 1px solid rgba(255, 255, 255, 0.2);*/
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1); /* 统一过渡动画 */
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1; /* 未选中项的基础层级 */
}

.slider-image {
    border-radius: 16px 16px 16px 16px;
    border: 1px solid;
    width: 100%;
    height: 250px; /* 固定高度 */
    object-fit: cover;
    transition: transform 0.3s ease;
    flex-shrink: 0; /* 防止图片被压缩 */
}

/* 选中状态下的图片样式调整 */
.slider-image-item.selected .slider-image {
    border: 0px;
    height: 300px; /* 调整图片高度，与容器高度匹配 */
    object-fit: cover; /* 确保图片填充整个区域 */
    background: rgba(0, 0, 0, 0.1); /* 添加背景色 */
    object-position: center; /* 确保图片居中显示 */
}

/* 图片悬停效果已注释掉 */
/* .slider-image:hover {
  transform: scale(1.05);
} */

/* 选中状态样式 - 科技感效果 */
.slider-image-item.selected {
    opacity: 1;

    /*border: 2px solid rgba(166, 245, 93, 1);*/
    /*box-shadow: */
    /*  0 0 20px rgba(166, 245, 93, 0.6),*/
    /*  0 0 40px rgba(166, 245, 93, 0.4);*/
    border-radius: 16px 16px 16px 16px;
    border: 1px solid;
    /*transform: scale(1.05);*/
    position: relative;
    z-index: 10; /* 提升层级避免被其他元素遮挡 */
    background: rgba(255, 255, 255, 0.1); /* 保持原有背景，去掉绿色 */
    backdrop-filter: blur(10px);
    height: 530px; /* 减少高度，减少底部空白 */
    width: 400px; /* 减小宽度避免过度遮挡 */
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1); /* 添加平滑过渡动画 */
}

/* 选中状态的发光边框效果 - 已注释掉 */
/* .slider-image-item.selected::before {
  content: '';
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  background: linear-gradient(45deg,
    rgba(166, 245, 93, 0.8),
    rgba(166, 245, 93, 0.4),
    rgba(166, 245, 93, 0.8),
    rgba(166, 245, 93, 0.4));
  border-radius: 16px;
  z-index: -1;
  animation: techGlow 2s ease-in-out infinite alternate;
} */

/* 科技感发光动画 - 已注释掉 */
/* @keyframes techGlow {
  0% {
    box-shadow:
      0 0 15px rgba(166, 245, 93, 0.5),
      0 0 30px rgba(166, 245, 93, 0.3);
  }
  100% {
    box-shadow:
      0 0 25px rgba(166, 245, 93, 0.8),
      0 0 50px rgba(166, 245, 93, 0.5);
  }
} */

/* 选中状态的图片效果 */
.slider-image-item.selected .slider-image {
    filter: brightness(1.1) contrast(1.1) saturate(1.2);
    transition: all 0.3s ease;
}

/* 确认选中状态 - 缩回原大小，添加明显的绿色边框 */
.slider-image-item.confirmed {
    width: 250px !important; /* 缩回原来的宽度 */
    height: 250px !important; /* 缩回原来的高度 */
    border: 3px solid #A6F55D !important; /* 明显的绿色边框 */
    box-shadow: 0 0 20px rgba(166, 245, 93, 0.6), 0 0 40px rgba(166, 245, 93, 0.3) !important; /* 更强的发光效果 */
    opacity: 1 !important; /* 选中项透明度为1 */
}

/* 确认选中状态下的图片也要缩回 */
.slider-image-item.confirmed .slider-image {
    height: 250px !important; /* 图片高度也缩回 */
    filter: brightness(1.1) contrast(1.1) saturate(1.2) !important; /* 保持图片亮度 */
}

/* 未选中状态 - 降低透明度 */
.slider-image-item.unselected {
    opacity: 0.4 !important;
}

/* 确认对勾标记 */
.confirmed-badge {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
    animation: confirmBadgeAppear 0.4s ease-out;
}

@keyframes confirmBadgeAppear {
    0% {
        transform: scale(0);
        opacity: 0;
    }
    50% {
        transform: scale(1.2);
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}

/* 内联产品详细信息样式 */
.product-details-inline {
    padding: 12px;
    background: rgba(0, 0, 0, 0.4); /* 去掉绿色，使用深色背景 */
    backdrop-filter: blur(10px);
    border-top: 1px solid rgba(255, 255, 255, 0.2); /* 改为白色边框 */
    flex: 1;
    display: flex;
    flex-direction: column;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1); /* 添加过渡动画 */
}

.product-header {
    display: flex;
    align-items: baseline; /* 价格和名称底部对齐 */
    gap: 8px; /* 价格和名称之间的间距 */
    margin-bottom: 5%; /* 整体头部与描述的间距 */
}

.product-details-inline .product-price {
    font-size: 20px;
    font-weight: 800;
    color: rgba(255, 255, 255, 1); /* 改为白色 */
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5); /* 改为黑色阴影 */
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    padding: 4px 8px; /* 添加内边距 */
    display: inline-block; /* 让边框只包围文字 */
}

/* 价格边框效果 - 与按钮相同但无圆角 */
.product-details-inline .product-price::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg,
    rgba(255, 255, 255, 1),
    rgba(204, 204, 204, 0.8),
    rgba(204, 204, 204, 0.4),
    rgba(204, 204, 204, 0.4),
    rgba(204, 204, 204, 0.8),
    rgba(255, 255, 255, 0.9));
    border-radius: 6px; /* 添加圆角效果 */
    padding: 1px;
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: xor;
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    z-index: -1;
}

.product-details-inline .product-name {
    font-size: 25px;
    font-weight: 800;
    color: rgba(255, 255, 255, 0.95);
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    text-align: left;
    font-style: normal;
    text-transform: none;
}

.product-details-inline .product-description {
    font-size: 22px;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.4;
    /*max-height: 40px;*/
    height: 150px;
    font-weight: 800;
    overflow: hidden;
    /*display: -webkit-box;*/
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}


/* ImageWithList 样式 */
.imagewithlist-container {
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.imagewithlist-image-container {
    width: 100%;
    max-width: 800px;
    min-height: 800px;
    margin-bottom: 20px;
    position: relative;
    display: inline-block;
}

.imagewithlist-image {
    width: 100%;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.imagewithlist-qr {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 35%;
    max-width: 280px;
    aspect-ratio: 1 / 1;
    /*background: #ffffff;*/
    border-radius: 12px;
    /*box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);*/
    padding: 16px;
    object-fit: contain;
}

.imagewithlist-caption {
    text-align: center;
    font-size: 32px;
    line-height: 1.4;
}

.imagewithlist-action-button {
    width: 100%;
    display: flex;
    justify-content: center;
}

.imagewithlist-confirm-btn {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 25px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.imagewithlist-confirm-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
}

.imagewithlist-confirm-btn:active {
    transform: translateY(0);
}

/* editImage4 按钮样式 */
.editimage4-action-button {
    display: flex;
    gap: 12px;
    justify-content: center;
    margin-top: 0.3;
}

.editimage4-action-button .editimage4-confirm-btn {
    flex: 1;
    font-size: 38px;
    max-width: 460px;
    height: 100px;
}

/* editImage4 独立样式 - 高优先级 */
.ai-text-container .editimage4-grid-container {
    margin-top: 16px;
    width: 100%;
}

.ai-text-container .editimage4-grid {
    display: flex !important;
    flex-wrap: nowrap !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    gap: 6px !important;
    margin-bottom: 20px !important;
    scroll-behavior: smooth !important;
    padding-bottom: 8px !important;
    -webkit-overflow-scrolling: touch !important;
    /*scrollbar-width: thin !important;*/
    -ms-overflow-style: auto !important;
}

/* 这个样式将在下面重新定义 */

/* 滑动样式优化 */
.ai-text-container .editimage4-grid {
    /* 滚动条样式优化 */
    scrollbar-width: none;
    scrollbar-color: rgba(255, 255, 255, 0.3) transparent !important;
}

.ai-text-container .editimage4-grid::-webkit-scrollbar {
    height: 6px !important;
    background: transparent !important;
}

.ai-text-container .editimage4-grid::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3) !important;
    border-radius: 3px !important;
}

.ai-text-container .editimage4-grid::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5) !important;
}

/* 禁用状态样式 */
.editimage4-grid-item.disabled {
    opacity: 0.6 !important;
    pointer-events: none !important;
    cursor: not-allowed !important;
}

/* 动画效果 */
.editimage4-grid-image.animating {
    animation: imagePulse 1s ease-in-out !important;
}

/* 过渡动画样式 */
/* 收缩动画：从下向上收起，上边框保持不动 */
.collapse-enter-active, .collapse-leave-active {
    transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out; /* Safari/iOS 兼容 */
    transform-origin: top center; /* 固定上边框为缩放原点 */
    -webkit-transform-origin: top center; /* Safari/iOS 兼容 */
    overflow: hidden;
    will-change: transform, opacity, max-height; /* 提示浏览器优化这些属性 */
    -webkit-backface-visibility: hidden; /* 减少移动端闪烁 */
    backface-visibility: hidden;
}

.collapse-enter-from {
    opacity: 0;
    transform: scaleY(0) translateZ(0); /* 添加 translateZ 启用硬件加速 */
    -webkit-transform: scaleY(0) translateZ(0); /* Safari/iOS 兼容 */
    max-height: 0;
}

.collapse-leave-to {
    opacity: 0;
    transform: scaleY(0) translateZ(0); /* 添加 translateZ 启用硬件加速 */
    -webkit-transform: scaleY(0) translateZ(0); /* Safari/iOS 兼容 */
    max-height: 0;
}

.collapse-enter-to, .collapse-leave-from {
    opacity: 1;
    transform: scaleY(1) translateZ(0); /* 添加 translateZ 启用硬件加速 */
    -webkit-transform: scaleY(1) translateZ(0); /* Safari/iOS 兼容 */
    max-height: 2000px;
}

@media (orientation: portrait) {
    .collapse-enter-active, .collapse-leave-active {
        transition: all 0.3s ease-in-out !important;
        -webkit-transition: all 0.3s ease-in-out !important;
    }
    
    /* 竖屏时增强打字动画效果 */
    .typing-dots span {
        animation: typing-mobile 1.2s infinite ease-in-out !important;
        -webkit-animation: typing-mobile 1.2s infinite ease-in-out !important;
        transform: translateZ(0); /* 启用硬件加速 */
        -webkit-transform: translateZ(0);
        width: 32px !important; /* 稍微大一点 */
        height: 32px !important;
    }
}

.fade-enter-active, .fade-leave-active {
    transition: all 0.3s ease;
}

.fade-enter-from {
    opacity: 0;
    transform: translateY(10px);
}

.fade-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

.fade-enter-to, .fade-leave-from {
    opacity: 1;
    transform: translateY(0);
}

@keyframes imagePulse {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}

.editimage4-grid-item {
    position: relative !important;
    border-radius: 12px !important;
    overflow: visible !important;
    /*background: rgba(255, 255, 255, 0.05) !important;*/
    border: none !important;
    transition: all 0.3s ease !important;
    cursor: pointer !important;
    flex-shrink: 0 !important;
    width: calc(25% - 4.5px) !important;
    min-width: calc(25% - 4.5px) !important;
    max-width: calc(25% - 4.5px) !important;
    height: auto !important;
    min-height: unset !important;
    /*box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;*/
    display: flex !important;
    flex-direction: column !important;
}

.editimage4-grid-item.selected {
    border: none !important;
    /*transform: scale(1.03) !important;*/
    /*box-shadow: 0 0 25px rgba(166, 245, 93, 0.6), 0 4px 12px rgba(0, 0, 0, 0.15) !important;*/
    /*background: rgba(166, 245, 93, 0.1) !important;*/
}

/* 确认后选中的图片 - 保持完全可见 */
.editimage4-grid-item.confirmed {
    opacity: 1 !important;
}

/* 确认后未选中的图片 - 降低透明度 */
.editimage4-grid-item.unselected {
    opacity: 0.5 !important;
    transition: opacity 0.3s ease !important;
}

/* 锁定状态 - 禁止点击 */
.editimage4-grid-item.locked {
    cursor: not-allowed !important;
    pointer-events: none !important;
}

.ai-text-container .editimage4-grid-image {
    width: 100%;
    height: 100%;
    min-height: 200px;
    object-fit: contain;
    object-position: center;
    transition: all 0.3s ease;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    display: block;
    border: 2px solid rgba(255, 255, 255, 0.15);
    order: 1;
}

.editimage4-grid-item.selected .editimage4-grid-image {
    border: 3px solid #FFFFFF;
}

.editimage4-grid-item p {
    font-weight: 300;
    font-size: 24px;
    color: #FFFFFF;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin: 10px 0 0 0;
    padding: 0;
    order: 2;
}

.editimage4-selected-indicator {
    position: absolute !important;
    top: 4px !important;
    right: 4px !important;
    width: 20px !important;
    height: 20px !important;
    background: rgba(166, 245, 93, 1) !important;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
    z-index: 10 !important;
}

.editimage4-checkmark {
    color: white !important;
    font-size: 12px !important;
    font-weight: bold !important;
}

.editimage4-selected-display {
    margin-top: 20px !important;
    text-align: center !important;
    width: 100% !important;
    display: block !important;
    transform-origin: top center !important; /* 确保从上边框开始收缩 */
    -webkit-transform-origin: top center !important; /* Safari/iOS 兼容 */
    overflow: hidden !important; /* 隐藏溢出内容 */
    -webkit-backface-visibility: hidden !important; /* 移动端优化 */
    backface-visibility: hidden !important;
    -webkit-perspective: 1000px !important; /* 启用3D加速 */
    perspective: 1000px !important;
}

.editimage4-image-container {
    position: relative !important;
    display: inline-block !important;
    max-width: 1150px !important;
    width: 100% !important;
    margin: 0 auto !important;
    transform-origin: top center !important; /* 确保从上边开始收缩 */
    -webkit-transform-origin: top center !important; /* Safari/iOS 兼容 */
    -webkit-backface-visibility: hidden !important; /* 移动端优化 */
    backface-visibility: hidden !important;
}

.editimage4-nav-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.6);
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 10;
}

.ai-text-container .editimage4-nav-btn:hover {
    background: rgba(0, 0, 0, 0.8);
    transform: translateY(-50%) scale(1.1);
}

.ai-text-container .editimage4-prev-btn {
    left: 10px;
}

.ai-text-container .editimage4-next-btn {
    right: 10px;
}

.ai-text-container .editimage4-large-image {
    width: 100% !important;
    /*max-width: 600px !important;*/
    /*height: 700px !important;*/
    object-fit: cover !important;
    border-radius: 12px !important;
    margin-bottom: 16px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
    display: block !important;
}

.ai-text-container .editimage4-image-info {
    margin-bottom: 20px;
    text-align: left;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
}

.ai-text-container .editimage4-action-button {
    margin-top: 20px !important;
    display: flex !important;
    gap: 12px !important;
    justify-content: center !important;
    width: 100% !important;
}

.ai-text-container .editimage4-confirm-btn {
    background: rgba(0, 0, 0, 0.8);
    color: white;
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    /*font-size: 16px;*/
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.ai-text-container .editimage4-confirm-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg,
    rgba(255, 255, 255, 1),
    rgba(204, 204, 204, 0.8),
    rgba(204, 204, 204, 0.4),
    rgba(204, 204, 204, 0.4),
    rgba(204, 204, 204, 0.8),
    rgba(255, 255, 255, 0.9));
    border-radius: 8px;
    padding: 1px;
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: xor;
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    z-index: -1;
}

.ai-text-container .editimage4-confirm-btn:hover {
    background: rgba(0, 0, 0, 0.9);
    transform: translateY(-2px);
}

/* 产品提示文本样式 */
.product-prompt-text {
    font-size: 36px;
    font-weight: 700;
    color: #FFFFFF;
    text-align: left;
    font-style: normal;
    text-transform: none;
}

/* Text1场景样式 - 产品选择后的需求询问 */
.text1-content {
    display: flex;
    flex-direction: column;
    /*gap: 12px;*/
    text-align: left;
}

.text1-opening {
    font-size: 38px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.95);
    line-height: 1.6;
    margin: 0;
}

.text1-prompt {
    font-size: 30px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.95);
    line-height: 1.6;
    margin: 8px 0 0 0;
}

.text1-section {
    margin: 8px 0;
}

.text1-label {
    font-size: 34px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.95);
    line-height: 1.6;
    margin: 0 0 4px 0;
}

.text1-label strong {
    font-weight: 600;
}

.text1-options {
    font-size: 30px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.95);
    line-height: 1.6;
    margin: 4px 0 0 0;
}

.text1-closing {
    font-size: 30px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.95);
    line-height: 1.6;
    margin: 12px 0 0 0;
}

/* 操作按钮样式 - 科技感 */
.product-actions {
    display: flex;
    gap: 16px;
    margin-top: 20px;
    justify-content: center;
}

.action-btn {
    padding: 14px 28px;
    border: none;
    border-radius: 12px;
    font-size: 38px;
    /*font-weight: 600;*/
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 460px;
    height: 100px;
    position: relative;
    overflow: hidden;
}

/* 按钮边框效果 - 与ai-text-container相同 */
.action-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg,
    rgba(255, 255, 255, 1),
    rgba(204, 204, 204, 0.8),
    rgba(204, 204, 204, 0.4),
    rgba(204, 204, 204, 0.4),
    rgba(204, 204, 204, 0.8),
    rgba(255, 255, 255, 0.9));
    border-radius: 12px;
    padding: 1px;
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: xor;
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    z-index: -1;
}

.select-btn {
    background: rgba(0, 0, 0, 0.3);
    color: rgba(255, 255, 255, 0.98);
}

.select-btn:hover {
    background: rgba(166, 245, 93, 1);
    transform: translateY(-2px);
}

.skip-btn {
    background: rgba(0, 0, 0, 0.3);
    color: rgba(255, 255, 255, 0.9);
}

.skip-btn:hover {
    background: rgba(0, 0, 0, 0.5);
    color: rgba(255, 255, 255, 1);
    transform: translateY(-2px);
}

.edit-image-center {
    display: flex;
    justify-content: center;
    width: 100%;
}

/* API数据显示区域样式 */
.api-data-display {
    background: rgba(0, 0, 0, 0.8);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    padding: 16px;
    margin: 16px 0;
    color: white;
    font-size: 14px;
}

.api-data-display h3 {
    margin: 0 0 12px 0;
    color: #4CAF50;
    font-size: 16px;
}

.api-data-content p {
    margin: 8px 0;
    line-height: 1.4;
}

.api-data-content strong {
    color: #FFD700;
    margin-right: 8px;
}

/* 让 editImage 场景的消息区域与其他场景保持一致的长度 */
.message.ai[data-scenario="editImage"] .ai-text-container {
    /* 确保ai-text-container宽度一致 */
    width: 100%;
}

.simple-response {
    padding: 0 25px;
    margin: 0;
    line-height: 1.6;
    opacity: 1;
    font-size: 38px;
    white-space: pre-wrap; /* 文本自动换行 */
    word-break: break-word; /* 长单词断行 */
    overflow-wrap: anywhere; /* 连续字符也断行 */
    text-align: left !important; /* 强制左对齐 */
    display: block;
    font-weight:800;
    width: 100%;
    color: rgba(255, 255, 255, 0.95);
}

.simple-responseImg {
    margin: 4px;
    line-height: 1.6;
    opacity: 0.9;
    font-size: 13px;
    word-break: break-word; /* 长单词断行 */
    overflow-wrap: anywhere; /* 连续字符也断行 */
    text-align: left !important; /* 强制左对齐 */
    display: block;
    width: 100%;
}

/* 场景4：左边两排商品，右边详情面板样式 */
.ai-scenario4-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 6px;
    justify-content: flex-start;
    padding-left: 0;
    margin-top: -4px;
}

/* 场景4专用的AI消息样式 */
.message.ai[data-scenario="Scenario4Layout"] {
    margin-right: -12%;
    padding-left: 20px;
    padding-right: 20px;
    margin-top: -8px;
}

.scenario4-layout {
    display: grid;
    grid-template-columns: 1fr 225px;
    gap: 19px;
    width: 100%;
    align-items: stretch; /* 让右侧面板与左侧网格等高 */
}

/* 左边商品网格 */
.scenario4-products-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 12px;
    padding: 0;
}

.scenario4-product-card {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 8px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    min-height: 180px;
}

.scenario4-product-card:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.25);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.scenario4-product-card.selected {
    background: rgba(76, 175, 80, 0.15);
    border: 2px solid #ABFF66;
    /*box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.3), 0 6px 20px rgba(76, 175, 80, 0.4);*/
    /*transform: translateY(-2px);*/
    /*animation: selectedPulse 2s ease-in-out infinite;*/
}

.scenario4-product-image {
    width: 100%;
    height: 100px;
    border-radius: 8px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.05);
}

.scenario4-product-card:hover .scenario4-product-img {
    transform: scale(1.05);
}

.scenario4-product-card.selected .scenario4-product-name {
    color: #4CAF50;
    font-weight: 700;
}

.scenario4-product-card.selected .scenario4-product-price {
    background: rgba(76, 175, 80, 0.8);
    color: #fff;
}

/* 右边详情面板 */
.scenario4-detail-panel {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    padding: 16px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(10px);
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 225px;
    margin-left: -4px;
    position: relative;
    z-index: 1;
    height: 100%; /* 拉伸至与左侧等高 */
}

.scenario4-detail-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 100%;
}

.scenario4-detail-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.scenario4-detail-title {
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    margin: 0;
}

.scenario4-detail-nav {
    display: flex;
    gap: 8px;
}

.scenario4-nav-btn {
    width: 24px;
    height: 24px;
    border: none;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    transition: background 0.3s ease;
}

.scenario4-nav-btn:hover {
    background: rgba(255, 255, 255, 0.2);
}

.scenario4-detail-info {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    min-height: 146px;
    position: relative;
}

.scenario4-detail-image {
    width: 120px;
    height: 130px;
    /*object-fit: cover;*/
    border-radius: 6px;
    transition: transform 0.3s ease;
}

.scenario4-detail-image:hover {
    transform: scale(1.02);
}

.scenario4-nav-left {
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
}

.scenario4-nav-right {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
}

.scenario4-detail-pagination {
    display: flex;
    justify-content: center;
    gap: 8px;
    margin: 8px 0;
}

.scenario4-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.3);
    transition: background 0.3s ease;
}

.scenario4-dot.active {
    background: rgba(255, 255, 255, 0.8);
}

.scenario4-detail-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
    text-align: left;
}

.scenario4-detail-brand {
    font-size: 16px;
    font-weight: 600;
    color: #fff;
}

.scenario4-detail-name {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.4;
}

.scenario4-detail-price-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: -10px;
}

.scenario4-detail-link-row {
    margin-bottom: 12px;
}

.scenario4-detail-price {
    font-size: 16px;
    font-weight: 600;
    color: #fff;
}

.scenario4-detail-link {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
    text-decoration: underline;
    transition: color 0.3s ease;
}

.scenario4-detail-link:hover {
    color: #4CAF50;
}

.scenario4-heart-icon {
    width: 20px;
    height: 20px;
    color: rgba(255, 255, 255, 0.6);
    cursor: pointer;
    transition: color 0.3s ease;
    margin-left: auto;
}

.scenario4-heart-icon:hover {
    color: #ff6b6b;
}

.scenario4-detail-actions {
    display: flex;
    gap: 12px;
    margin-top: auto;
}

.scenario4-action-btn {
    flex: 1;
    padding: 10px 12px;
    border: none;
    border-radius: 8px;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
}

.scenario4-action-btn.buy-btn {
    background: #f5f5f5;
    color: #000;
    border: 1px solid #ddd;
}

.scenario4-action-btn.buy-btn:hover {
    background: #e8e8e8;
}

.scenario4-action-btn.try-btn {
    background: #333;
    color: #fff;
    border: none;
}

.scenario4-action-btn.try-btn.disabled,
.scenario4-action-btn.try-btn:disabled {
    background: #666;
    cursor: not-allowed;
    opacity: 0.6;
}

.scenario4-action-btn.try-btn:hover {
    background: #444;
}

/* 场景4：四个产品卡片网格样式 */
.ai-step4-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: flex-start;
    padding-left: 0;
}

.step4-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    width: 100%;
}

.step4-card {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 8px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    display: grid;
    grid-template-columns: 120px 1fr;
    gap: 8px;
    align-items: stretch;
    overflow: hidden;
}


.step4-card-image {
    width: 100%;
    border-radius: 6px;
    overflow: hidden;
}

.step4-model-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.step4-card-items {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 8px;
    padding: 0;
    width: 100%;
    overflow: hidden;
}

@media (max-width: 1024px) {
    .step4-card-items {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
    }

    .step4-item:nth-child(3) {
        grid-column: 1 / 3;
        grid-row: 2;
        justify-self: center;
        max-width: 50%;
    }
}

@media (max-width: 480px) {
    .step4-card-items {
        grid-template-columns: 1fr;
        grid-template-rows: repeat(3, 1fr);
    }

    .step4-item:nth-child(3) {
        grid-column: 1;
        grid-row: 3;
        justify-self: center;
        max-width: 100%;
    }
}

.step4-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 6px;
    border-radius: 8px;
    position: relative;
    min-height: 140px;
    width: 100%;
    overflow: hidden;
}

.step4-item:nth-child(3) {
    grid-column: 1 / 3;
    grid-row: 2;
    justify-self: center;
    max-width: 50%;
}


.step4-item-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 8px;
    width: 100%;
}

.step4-item-number {
    font-size: 16px;
    font-weight: 700;
    color: #000000;
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
}

.step4-item-title {
    font-size: 13px;
    color: #000000;
    font-weight: 500;
    flex: 1;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}

.step4-item-thumb {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 6px;
    flex-shrink: 0;
    transition: all 0.3s ease;
}

.step4-item-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: 100%;
    margin-top: 8px;
}

.step4-item-price {
    background: #000000;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 600;
    color: #ffffff;
    white-space: nowrap;
    max-width: 100%;
}

.step4-item-heart {
    width: 18px;
    height: 18px;
    color: #000000;
    fill: none;
    stroke: currentColor;
    stroke-width: 1.5;
}

/* 商品卡片头部：序号 + 标题 */
.ai-item-header {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
    width: 100%;
}

.ai-item-number {
    font-size: 14px;
    font-weight: 700;
    color: #000000;
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
}

.ai-item-title {
    font-size: 12px;
    color: #000000;
    font-weight: 500;
    flex: 1;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 商品卡片底部：价格 + 心形图标 */
.ai-item-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
    width: 100%;
    margin-top: 8px;
}

.ai-message .message-time {
    font-size: 11px;
    opacity: 0.6;
    margin-top: 8px;
}

/* 打字指示器 */
.typing-indicator .message-content {
    padding: 12px 16px;
}

.typing-indicator-line {
    display: flex;
    align-items: center;
    gap: 10px;
}

.typing-status-text {
    color: rgba(255, 255, 255, 0.85);
    font-size: 37px;
    font-weight: 500;
    line-height: 1.4;
}

.moodboard-loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.moodboard-loading-frame {
    position: relative;
    /*width: 220px;*/
    height: 360px;
    overflow: hidden;
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: radial-gradient(120% 120% at 50% 50%, rgba(60, 60, 60, 0.4) 0%, rgba(10, 10, 10, 0.9) 100%);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(6px);
}

.moodboard-loading-track {
    display: flex;
    width: 100%;
    height: 100%;
    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.moodboard-loading-slide {
    flex: 0 0 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px;
}

.moodboard-loading-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: drop-shadow(0 12px 22px rgba(0, 0, 0, 0.4));
    transition: transform 0.4s ease;
}

.moodboard-loading-frame::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    pointer-events: none;
}

.moodboard-loading-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0) 45%, rgba(255, 255, 255, 0.08) 100%);
    mix-blend-mode: screen;
    pointer-events: none;
}

.typing-dots {
    display: flex;
    gap: 4px;
    align-items: center;
}

.typing-dots span {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.6);
    animation: typing 1.4s infinite ease-in-out;
    -webkit-animation: typing 1.4s infinite ease-in-out; /* Safari/iOS 兼容 */
    will-change: transform, opacity; /* 提示浏览器优化 */
    -webkit-backface-visibility: hidden; /* 减少移动端闪烁 */
    backface-visibility: hidden;
}

.typing-dots span:nth-child(1) {
    animation-delay: -0.32s;
}

.typing-dots span:nth-child(2) {
    animation-delay: -0.16s;
}

.typing-dots span:nth-child(3) {
    animation-delay: 0s;
}

@keyframes typing {
    0%, 80%, 100% {
        transform: scale(0.8);
        opacity: 0.5;
    }
    40% {
        transform: scale(1);
        opacity: 1;
    }
}

/* 移动端专用动画 - 更明显的跳动效果 */
@keyframes typing-mobile {
    0%, 80%, 100% {
        transform: scale(0.6) translateZ(0);
        opacity: 0.3;
    }
    40% {
        transform: scale(1.2) translateZ(0);
        opacity: 1;
    }
}


/* 输入区域容器 */
.input-container {
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: -150px; /* 移动到更底部，避免挡住内容 */
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px;
    background: rgb(171 171 171 / 95%);
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
    transition: box-shadow 0.3s ease;
    /* 性能优化 */
    will-change: transform;
    transform: translateZ(0);
    backface-visibility: hidden;
    perspective: 1000px;
}

/* 语音录音组件样式 */
.voice-recorder-component {
    position: absolute;
    right: -2%;
    top: 70%;
    transform: translateY(-50%);
    touch-action: none;
    overscroll-behavior: none;
    -webkit-overflow-scrolling: auto;
    z-index: 1000;
}


/* 输入容器获得焦点时的样式 - 移除过渡避免跳动 */
.input-container:focus-within {
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}

/* 输入栏样式 */
.input-bar {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 0;
    padding: 0;
    border-radius: 8px;
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);
    height: 70px; /* 恢复正常高度，因为现在在容器外部 */
    /* 移除过渡动画避免跳动 */
    position: relative;
    /* 性能优化 */
    will-change: auto;
    transform: translateZ(0);
    contain: layout style paint;
}

/* 输入栏获得焦点时的样式 */
.input-bar:focus-within {
    border-color: #4CAF50;
    background: #ffffff;
    box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.1);
}

/* 添加一个内部发光效果 */
.input-bar::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 8px;
    background: linear-gradient(45deg, rgba(76, 175, 80, 0.05), rgba(76, 175, 80, 0.02));
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
    z-index: 1;
}

.input-bar:focus-within::before {
    opacity: 1;
}

.input-bar input {
    flex: 1;
    height: 48px;
    border-radius: 25px;
    border: none;
    padding: 0 20px;
    outline: none;
    background: transparent;
    color: #666;
    font-size: 14px;
    transition: color 0.3s ease, background-color 0.3s ease;
    position: relative;
    z-index: 2;
    /* 性能优化 */
    will-change: auto;
    transform: translateZ(0);
    contain: layout;
}

/* 输入框获得焦点时的样式 */
.input-bar input:focus {
    color: #333;
    background: transparent;
}

.input-bar input:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.input-bar input::placeholder {
    color: #aaa;
    transition: color 0.3s ease, opacity 0.3s ease;
}

.input-bar input:focus::placeholder {
    color: #999;
    opacity: 0.8;
}

/* 相机按钮 */
.btn-attach {
    border: none;
    border-radius: 8px;
    width: 50px;
    height: 70px; /* 与输入框高度匹配 */
    margin: 4px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    /* 移除过渡动画避免跳动 */
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: #7CB342;
    color: white;
    position: relative;
    overflow: hidden;
    padding: 0;
    /* 性能优化 */
    will-change: transform, background-color;
    transform: translateZ(0);
    backface-visibility: hidden;
}

.btn-attach:hover:not(:disabled) {
    background: #689F38;
    transform: translateY(-1px);
}

.btn-attach:active:not(:disabled) {
    transform: translateY(0) scale(0.95);
    transition: all 0.1s ease;
}

/* 上传图标样式 */
.upload-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
    transition: opacity 0.3s ease;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

/* 默认图标 */
.default-icon {
    opacity: 1;
    z-index: 1;
}

.default-icon.hidden {
    opacity: 0;
}

/* 悬浮图标 */
.hover-icon {
    opacity: 0;
    z-index: 3;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    padding: 4px;
    transition: opacity 0.3s ease;
}

.btn-attach:hover .hover-icon {
    opacity: 1;
}

.btn-attach:hover .uploaded-image {
    opacity: 0.7; /* 悬浮时显示上传的图片作为背景 */
}

/* 上传后的图片 */
.uploaded-image {
    opacity: 1;
    z-index: 2;
    border-radius: 4px;
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
    object-position: center;
}

/* 点击波纹动画 */
.btn-attach::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.3);
    transform: translate(-50%, -50%) scale(0);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 4;
    will-change: transform;
}

.btn-attach:active::before {
    transform: translate(-50%, -50%) scale(2.5);
    width: 40px;
    height: 40px;
}

/* 发送按钮（在输入框内） */
.btn-send {
    border: none;
    border-radius: 8px;
    width: 50px;
    height: 50px;
    margin: 4px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    /* 移除过渡动画避免跳动 */
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: #666;
    color: white;
    position: relative;
    overflow: hidden;
    /* 性能优化 */
    will-change: transform, background-color;
    transform: translateZ(0);
    backface-visibility: hidden;
}

.btn-send:hover:not(:disabled) {
    background: #555;
    /* 移除transform避免跳动 */
}

.btn-send:active:not(:disabled) {
    background: #444;
    /* 移除transform避免跳动 */
}

/* 移除波纹动画避免跳动 */

.btn-attach:disabled, .btn-send:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
}

.hidden-input {
    display: none;
}

/* 图片预览样式 */
.image-preview {
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 90px; /* 在输入栏上方 */
    background: rgba(152, 145, 145, 0.95);
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    padding: 12px;
    z-index: 10;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    /* 性能优化 */
    will-change: transform, opacity;
    transform: translateZ(0);
    backface-visibility: hidden;
}

.preview-container {
    position: relative;
    display: inline-block;
}

.preview-image {
    max-width: 150px;
    max-height: 150px;
    border-radius: 8px;
    object-fit: cover;
    display: block;
}

.remove-image {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #ff4444;
    color: white;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: bold;
    transition: background 0.2s ease;
}

.remove-image:hover {
    background: #cc0000;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .dialog-page {
        height: 100vh;
        min-height: 100vh;
        max-height: 100vh;
        overflow: hidden;
    }

    .page-header {
        padding: 16px 16px 8px;
    }

    .page-title {
        font-size: 26px;
    }

    .hero {
        padding: 8px 16px; /* 减少padding */
    }

    .messages-container {
        padding: 8px 16px; /* 减少padding */
        padding-bottom: 100px; /* 增加底部间距，避免被输入框遮挡 */
        max-height: calc(100vh - 120px); /* 动态计算高度 */
        min-height: calc(100vh - 120px);
        overflow-y: auto;
        -webkit-overflow-scrolling: touch; /* iOS平滑滚动 */
    }

    .input-container {
        position: fixed;
        left: 16px;
        right: 16px;
        bottom: 20px; /* 固定在底部 */
        gap: 8px;
        padding: 8px;
        z-index: 1000;
        box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
    }

    .input-bar {
        height: 50px;
        border-radius: 25px;
    }

    .input-bar input {
        height: 48px;
        padding: 0 20px;
        font-size: 16px; /* 防止iOS缩放 */
        border-radius: 24px;
    }

    .products-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
    }

    .image-frame-area {
        grid-template-columns: 1fr 1fr 1fr;
        gap: 6px;
        padding: 8px;
    }

    .ai-item-frame {
        min-height: 140px;
        padding: 10px 8px;
    }

    .ai-item-frame-thumb {
        width: 100%;
        height: auto;
        max-height: 100px;
        object-fit: contain;
        display: block;
    }

    .ai-item-frame-name {
        font-size: 11px;
    }

    .ai-item-price {
        font-size: 10px;
        padding: 2px 6px;
    }

    .ai-item-heart {
        width: 18px;
        height: 18px;
    }

    .ai-item-index-overlay {
        width: 18px;
        height: 18px;
        font-size: 10px;
        top: 6px;
        left: 6px;
    }

    /* 场景4中等屏幕响应式样式 */
    .scenario4-layout {
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .scenario4-detail-panel {
        width: 100%;
        margin-left: 0;
    }

    .scenario4-products-grid {
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: repeat(3, 1fr);
        gap: 10px;
    }

    .scenario4-product-card {
        min-height: 170px;
        padding: 8px;
    }

    .scenario4-product-image {
        height: 90px;
    }

    .scenario4-detail-panel {
        padding: 18px;
        height: 300px;
    }

    .product-image {
        height: 200px; /* 增加移动端图片高度 */
    }

    .product-card {
        padding: 8px;
    }

    .selection-indicator {
        width: 20px;
        height: 20px;
        font-size: 12px;
        top: 6px;
        right: 6px;
    }

    .user-message .message-content,
    .ai-message .message-content {
        max-width: 85%;
    }

    .btn-attach {
        width: 50px;
        height: 50px;
        font-size: 14px;
        margin: 0;
        border-radius: 25px;
        min-width: 50px;
    }

    .btn-attach .upload-icon {
        width: 24px;
        height: 24px;
    }

    .btn-attach .uploaded-image {
        width: 100% !important;
        height: 100% !important;
    }

    .btn-send {
        width: 50px;
        height: 50px;
        font-size: 14px;
        margin: 0;
        border-radius: 25px;
        min-width: 50px;
    }

    .image-preview {
        left: 16px;
        right: 16px;
        bottom: 90px;
    }

    .preview-image {
        max-width: 120px;
        max-height: 120px;
    }

    /* 触摸友好的按钮样式 */
    .btn-attach:active,
    .btn-send:active {
        transform: scale(0.95);
        transition: transform 0.1s ease;
    }

    /* 消息气泡在移动端的优化 */
    .message {
        margin-bottom: 16px;
    }

    .user-message .message-content {
        padding: 12px 16px;
        border-radius: 20px 20px 4px 20px;
    }

    .ai-message .message-content {
        padding: 12px 16px;
        border-radius: 16px;
        background: rgba(60, 60, 80, 0.8);
        color: rgba(255, 255, 255, 0.95);
    }

    /* 打字指示器优化 */
    .typing-indicator .message-content {
        padding: 12px 16px;
    }
}

@media (max-width: 480px) {
    .dialog-page {
        height: 100vh;
        min-height: 100vh;
        max-height: 100vh;
    }

    .page-header {
        padding: 12px 12px 6px;
    }

    .page-title {
        font-size: 22px;
    }

    .messages-container {
        padding: 6px 12px;
        padding-bottom: 110px; /* 增加底部间距 */
        max-height: calc(100vh - 100px);
        min-height: calc(100vh - 100px);
    }

    .input-container {
        left: 12px;
        right: 12px;
        bottom: 16px;
        padding: 6px;
        gap: 6px;
    }

    .input-bar {
        height: 48px;
        border-radius: 24px;
    }

    .input-bar input {
        height: 46px;
        padding: 0 16px;
        font-size: 16px; /* 防止iOS缩放 */
        border-radius: 23px;
    }

    .ai-message {
        gap: 8px;
    }

    .ai-avatar {
        width: 32px;
        height: 32px;
        font-size: 16px;
    }

    .ai-avatar img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
    }

    .user-message .message-content,
    .ai-message .message-content {
        max-width: 90%;
        padding: 10px 14px;
    }

    .products-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
    }

    .product-image {
        height: 180px; /* 增加小屏幕图片高度 */
    }

    .product-card {
        padding: 6px;
    }

    .image-frame-area {
        grid-template-columns: 1fr 1fr 1fr;
        gap: 4px;
        padding: 6px;
    }

    .ai-item-frame {
        min-height: 130px;
        padding: 8px 6px;
    }

    .ai-item-frame-thumb {
        width: 100%;
        height: auto;
        max-height: 90px;
        object-fit: contain;
        display: block;
    }

    .ai-item-frame-name {
        font-size: 10px;
    }

    .ai-item-price {
        font-size: 9px;
        padding: 2px 5px;
    }

    .ai-item-heart {
        width: 16px;
        height: 16px;
    }

    .ai-item-index-overlay {
        width: 16px;
        height: 16px;
        font-size: 9px;
        top: 5px;
        left: 5px;
    }

    /* 场景4响应式样式 */
    .scenario4-layout {
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .scenario4-detail-panel {
        width: 100%;
        margin-left: 0;
    }

    .scenario4-products-grid {
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(4, 1fr);
        gap: 8px;
    }

    .scenario4-product-card {
        min-height: 160px;
        padding: 6px;
    }

    .scenario4-product-image {
        height: 80px;
    }

    .scenario4-detail-panel {
        padding: 16px;
        height: 300px;
    }

    .scenario4-detail-actions {
        flex-direction: column;
        gap: 8px;
    }

    /* 小屏幕按钮优化 */
    .btn-attach,
    .btn-send {
        width: 48px;
        height: 48px;
        border-radius: 24px;
        min-width: 48px;
    }

    .btn-attach .upload-icon {
        width: 22px;
        height: 22px;
    }

    /* 消息间距优化 */
    .message {
        margin-bottom: 12px;
    }

    /* 图片预览优化 */
    .image-preview {
        left: 12px;
        right: 12px;
        bottom: 80px;
    }

    .preview-image {
        max-width: 100px;
        max-height: 100px;
    }
}

/* 移动端触摸优化 */
@media (max-width: 768px) {
    /* 防止双击缩放和滚动 */
    * {
        touch-action: manipulation;
        overscroll-behavior: none;
    }
    
    /* 防止页面滚动 */
    body, html {
        overscroll-behavior: none;
        -webkit-overflow-scrolling: touch;
    }

    /* 优化触摸滚动 */
    .messages-container {
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: contain;
    }

    /* 触摸友好的按钮 */
    .btn-attach,
    .btn-send,
    .product-card,
    .scenario4-product-card,
    .ai-item-frame-three {
        min-height: 44px; /* iOS推荐的最小触摸目标 */
        min-width: 44px;
    }

    /* 防止文本选择 */
    .btn-attach,
    .btn-send {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* 优化长按行为 */
    .product-card:active,
    .scenario4-product-card:active,
    .ai-item-frame-three:active {
        transform: scale(0.98);
        transition: transform 0.1s ease;
    }
}

/* 超小屏幕优化 (320px以下) */
@media (max-width: 320px) {
    .input-container {
        left: 8px;
        right: 8px;
        bottom: 12px;
        padding: 4px;
        gap: 4px;
    }

    .input-bar {
        height: 44px;
    }

    .input-bar input {
        height: 42px;
        padding: 0 12px;
        font-size: 16px;
    }

    .btn-attach,
    .btn-send {
        width: 44px;
        height: 44px;
        border-radius: 22px;
        min-width: 44px;
    }

    .messages-container {
        padding: 4px 8px;
        padding-bottom: 100px;
    }

    .user-message .message-content,
    .ai-message .message-content {
        max-width: 95%;
        padding: 8px 12px;
    }

    .products-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 6px;
    }

    .product-image {
        height: 160px;
    }
}

/* 横屏模式优化 */
@media (max-width: 768px) and (orientation: landscape) {
    .dialog-page {
        height: 100vh;
        max-height: 100vh;
    }

    .messages-container {
        max-height: calc(100vh - 80px);
        min-height: calc(100vh - 80px);
        padding-bottom: 80px;
    }

    .input-container {
        bottom: 10px;
        padding: 4px;
    }

    .input-bar {
        height: 40px;
    }

    .input-bar input {
        height: 40px;
        padding: 0 16px;
    }

    .btn-attach,
    .btn-send {
        width: 40px;
        height: 40px;
        border-radius: 20px;
        min-width: 40px;
    }
}

/* 滚动条样式 */
.messages-container::-webkit-scrollbar {
    width: 0px;
    height: 0px;
}

/* 滚动条轨道 */
.messages-container::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
}

/* 滚动条滑块 */
.messages-container::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
    transition: background 0.2s ease;
}

.messages-container::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
}

/* 移动端滚动条优化 */
@media (max-width: 768px) {
    .messages-container::-webkit-scrollbar {
        width: 4px;
    }

    .messages-container::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.4);
    }
}
</style>


